{
    "base_title": "The Reflection",
    "base_title_ru": "SkillsTrainer",
    "404_title": "Page Not Found ⚠️",
    "404_description": "We couldn't find the page you are looking for.",
    "404_home": "Back to Home",
    "401_title": "You are not authorized! 🔐",
    "401_description": "You don’t have permission to access this page. Go Home!.",
    "401_home": "Back to Home",
    "changes_saved": "Changes saved",
    "coming_soon": "Coming soon",
    " ": " ",
    "select_date_and_time": "Select date and time",
    "select_date": "Select date",
    "chat": "Chat",
    "menu": "Menu",
    "games": "Sessions",
    "tours": "Tours",
    "library": "Library",
    "library-video": "Video",
    "library-scorm": "Courses",
    "library-documents": "Documents",
    "knowledge-base": "Knowledge Base",
    "courses": "Courses",
    "courses-page": {
        "title": "Courses",
        "create": "Create course",
        "edit": "Edit course",
        "empty": "No courses yet",
        "fields": {
            "title": "Title",
            "description": "Description",
            "documents-count": "Documents"
        },
        "headers": {
            "title": "Title",
            "description": "Description",
            "documents": "Documents",
            "actions": "Actions"
        },
        "dialog": {
            "title-label": "Title",
            "description-label": "Description",
            "documents-label": "Documents",
            "documents-placeholder": "Pick knowledge-base documents",
            "save": "Save",
            "cancel": "Cancel"
        },
        "messages": {
            "created": "Course created",
            "updated": "Course updated",
            "deleted": "Course deleted",
            "error": "Something went wrong"
        },
        "confirm-delete": "Delete this course? This cannot be undone."
    },
    "ai-study-chat": "AI study chat",
    "ai-study-chat-page": {
        "title": "AI study chat",
        "new-conversation": "New conversation",
        "empty-sidebar": "No conversations yet",
        "empty-thread": "Pick a course or scenario to start learning",
        "untitled": "New chat",
        "input-placeholder": "Type your question…",
        "send": "Send",
        "typing": "Assistant is typing…",
        "sources": "Sources ({count})",
        "sources-label": "Sources",
        "score": "relevance",
        "retry": "Retry",
        "copy": "Copy",
        "copied": "Copied",
        "failed": "Failed to send",
        "search-placeholder": "Search conversations",
        "search-empty": "Nothing found",
        "empty": {
            "heading": "Ready to help you learn",
            "subtitle": "Ask anything about the course materials — I'll find the answer in the knowledge base and show the sources."
        },
        "groups": {
            "today": "Today",
            "yesterday": "Yesterday",
            "earlier": "Earlier"
        },
        "composer": {
            "context": "Context:",
            "hint": "Answers are AI-generated from your materials · Enter to send, Shift+Enter for a new line"
        },
        "quota": {
            "remaining": "{count} messages left",
            "exhausted": "You've run out of AI chat messages.",
            "unavailable": "AI chat is not available on your plan."
        },
        "new-dialog": {
            "title": "New conversation",
            "subtitle": "Choose the source the AI will answer from",
            "source-type": "Source",
            "source-course": "Course",
            "source-scenario": "Scenario",
            "source-competency": "Competency",
            "pick-course": "Pick a course",
            "pick-scenario": "Pick a scenario",
            "pick-competency": "Pick a competency",
            "pick-target": "All games or a specific session",
            "all-games": "All games — my progress",
            "all-games-sub": "Score trends for this competency",
            "back": "Back",
            "no-games": "No completed games",
            "empty-competencies": "No completed games yet",
            "empty-competencies-hint": "Complete a game on a scenario with a competency — your AI debrief will appear here",
            "empty-courses": "No courses available yet",
            "empty-scenarios": "No scenarios available yet",
            "tag-game": "Game",
            "search": "Search…",
            "search-empty": "Nothing found",
            "start": "Start",
            "cancel": "Cancel"
        },
        "stage": {
            "searching": "Searching your materials…",
            "reading": "Reading sources…",
            "writing": "Writing the answer…",
            "writing_sources": "Analyzing {count} passages…",
            "summarizing_short": "Organizing earlier context",
            "searching_short": "Searching your materials",
            "reading_short": "Reading sources",
            "writing_short": "Writing the answer",
            "writing_sources_short": "Analyzing {count} passages"
        },
        "suggestions-fallback": [
            { "title": "Summarize the materials", "subtitle": "Key points" },
            { "title": "Build a study plan", "subtitle": "Where to start" },
            { "title": "Quiz me", "subtitle": "Quick check" },
            { "title": "Explain simply", "subtitle": "No jargon" }
        ],
        "suggestions-fallback-debrief": [
            { "title": "Debrief this game", "subtitle": "Key takeaways" },
            { "title": "What did I do well?", "subtitle": "My strengths" },
            { "title": "Where did I go wrong and why?", "subtitle": "Growth points" },
            { "title": "What should I improve next game?", "subtitle": "Concrete steps" }
        ],
        "suggestions-fallback-progress": [
            { "title": "How are my results trending?", "subtitle": "Across games" },
            { "title": "My strong and weak skills", "subtitle": "From game scores" },
            { "title": "What should I focus on?", "subtitle": "Training priority" },
            { "title": "Compare my first and latest games", "subtitle": "What improved" }
        ],
        "errors": {
            "send": "Couldn't send your message. Please try again.",
            "quota": "Message quota reached.",
            "rate_limit": "Too many requests. Please wait a minute and try again.",
            "provider_unsupported": "The knowledge base chat is not available with your organization's current AI provider.",
            "generic": "Something went wrong."
        }
    },
    "scenarios": "Scenarios",
    "competencies": "Competencies",
    "competencies-list": "List",
    "skills": "Skills",
    "home": "Home",
    "home_player": "Participant",
    "player": "Participant",
    "home_expert": "Expert",
    "reports-analytics-tours": "Tours",
    "reports": "Reports",
    "skill_reports": {
        "skill_development_report": "Skill Development Report",
        "generate": "Generate",
        "generate_description": "Generate a comprehensive skill development report for a selected period",
        "manager_description": "Generate skill development reports for employees in your organization",
        "date": "Date",
        "competence": "Competence",
        "period": "Period",
        "status_label": "Status",
        "actions": "Actions",
        "employee": "Employee",
        "view": "View report",
        "download_pdf": "Download PDF",
        "no_reports": "No reports generated yet",
        "data_not_available": "Report data is not available yet",
        "generation_failed": "Report generation failed",
        "retry": "Retry",
        "rate_limit_exceeded": "Report generation limit reached. Please try again later.",
        "too_many_pending": "You have too many reports in progress. Please wait for them to complete.",
        "no_games_for_report": "No completed sessions found for the selected period and competence. The report cannot be generated.",
        "report_already_exists": "A report with these parameters already exists. Check the list below.",
        "period_too_long": "The report period must not exceed one year.",
        "invalid_parameters": "Check the competence and the period",
        "filter_by_employee": "Filter by employee...",
        "batch": {
            "mode_single": "Single report",
            "mode_batch": "Batch",
            "load_employees": "Show employees",
            "sessions": "Sessions",
            "no_candidates": "No employees with completed sessions for the selected competence and period",
            "generate_selected": "Generate ({count})",
            "selected_limit": "You can select at most {max} employees at a time",
            "progress": "{ready} of {total} ready",
            "failed_count": "Failed: {count}",
            "status_unknown": "Status unknown",
            "status_unknown_hint": "The report was not found in the list — check the reports table below",
            "reused": "Reused reports: {count} — generated within the last {hours} h and not created again",
            "reused_badge": "Reused",
            "reused_on": "Generated on {date}",
            "download_all": "Download all",
            "toggle_details": "Show batch contents",
            "dismiss_confirm": "This batch is still being generated. Remove it from the screen? The progress and the “Download all” button will be lost; the reports stay in the list below.",
            "archive_unavailable": "The archive could not be built: some reports are not ready yet or are no longer available",
            "archive_failed": "Could not download the archive",
            "archive_building": "Building the archive…",
            "archive_build_failed": "Could not build the archive. Try again.",
            "candidates_failed": "Could not load the employee list",
            "stale_selection": "Some of the selected employees are no longer available. The list has been refreshed — select again."
        },
        "quota": {
            "remaining_hour": "Report limit: {limit} per hour. You can request {remaining} more right now. Select fewer employees or try again at {time}.",
            "remaining_day": "Report limit: {limit} per day. You can request {remaining} more right now. Select fewer employees or try again at {time}.",
            "exhausted_hour": "Report limit ({limit} per hour) reached. It will reset at {time}.",
            "exhausted_day": "Report limit ({limit} per day) reached. It will reset at {time}.",
            "too_large_hour": "Report limit: {limit} per hour. Select fewer employees.",
            "too_large_day": "Report limit: {limit} per day. Select fewer employees."
        },
        "status": {
            "pending": "Pending",
            "collecting_data": "Collecting data...",
            "analyzing": "AI Analysis...",
            "generating_pdf": "Generating PDF...",
            "ready": "Ready",
            "failed": "Failed"
        },
        "report": {
            "kicker": "Competency Development Report",
            "position": "Position",
            "department": "Department",
            "period": "Period",
            "games_count": "Sessions played",
            "not_specified_f": "Not specified",
            "not_specified_n": "Not specified",
            "fig": {
                "your_average": "Your average score",
                "company_average": "Company average",
                "participants": "Participants in the period",
                "skills_count": "Skills assessed"
            },
            "sec": {
                "profile": "Competency Profile",
                "trend": "Trend Across Sessions",
                "strengths": "What to Build On",
                "priorities": "Three Development Priorities",
                "skills": "Skill-by-Skill Breakdown",
                "plan": "Three-Month Plan"
            },
            "legend": {
                "you": "Your score",
                "company": "Company average"
            },
            "dotplot_caption": "Deviation from the average — from the largest lead to the largest gap",
            "trend_disclaimer": "Session scores are not directly comparable: cases differ in difficulty from one session to the next. A lower score does not in itself mean the skill has declined — this chart is an observation, not a verdict.",
            "no_comparison": "Comparison with the company average is unavailable: fewer than three people ran sessions in this competency during the period. The report is based on absolute scores.",
            "skill": {
                "works": "What works",
                "blocks": "What gets in the way",
                "actions": "What to do",
                "out_of_ten": "out of 10",
                "company_short": "company"
            },
            "level": {
                "outstanding": "Outstanding",
                "strength": "Strength",
                "meets_standard": "At company level",
                "needs_attention": "Needs attention",
                "needs_development": "Development area"
            },
            "plan": {
                "month": "Month",
                "goals": "Goals",
                "actions": "Actions"
            },
            "colophon": {
                "built_on": "The report is based on sessions held between {from} and {to}. Sessions in total: {count}.",
                "comparison": "Comparison is with the company average for the same period. Participants: {count}."
            }
        }
    },
    "ranking": "Ranking",
    "analytics": "Analytics",
    "support": "Support",
    "users": "Users",
    "participants": "Participants",
    "departments": "Departments",
    "positions": "Positions",
    "user-custom-fields": "Custom Fields",
    "administration": "Administration",
    "ai-assistants": "AI Assistants",
    "ai-prompts": "AI Prompts",
    "evaluation-rubrics": "Evaluation Rubrics",
    "ai-profiles": "AI Profiles",
    "ai-connectors": "AI Connectors",
    "Audit logs": "Audit logs",
    "organizations": "Organizations",
    "loading": "Loading...",
    "retry": "Retry",
    "previous": "Previous",
    "next": "Next",
    "save": "Save",
    "copy": "Copy",
    "copy_failed": "Could not copy automatically. Select the text in the field and copy it manually (Ctrl+C or ⌘C).",
    "confirm": "Confirm",
    "suggest": "Suggest",
    "generate": "Generate",
    "cancel": "Cancel",
    "close": "Close",
    "search": "Search...",
    "accept": "Accept",
    "propose": "Propose",
    "decline": "Decline",
    "send_request": "Send request",
    "assign": "Assign",
    "actions": " ",
    "evaluators": {
        "ai": "AI",
        "expert": "Expert",
        "player": "Participant",
        "manager": "Manager",
        "head": "Head"
    },
    "statistics": {
        "date_from": "From",
        "date_to": "To",
        "competence": "Competence",
        "evaluator": "Evaluator",
        "last_games_effectiveness": {
            "effectiveness": "Effectiveness",
            "title": "Effectiveness Progress"
        },
        "skill_trend": {
            "average_score": "Average Score",
            "game": "Session",
            "score": "Score",
            "title": "Average Score by Competencies"
        },
        "player_competence_radar": {
            "title": "Skill Statistics",
            "top": "Top 10",
            "players_in_company": "Participants in the company",
            "by_games": "Analytics by sessions",
            "subtitle": "Comparison with company average",
            "filter": "Filter",
            "you": "You",
            "company": "Company",
            "average_score": "average score",
            "skills_counted": "across {counted} of {total} skills"
        },
        "personal_radar": {
            "title": "My Competence Radar",
            "subtitle": "Your skills compared to organization average"
        },
        "skill_gap_heatmap": {
            "title": "Skill Gap Heatmap",
            "no_data": "No evaluation data available for the selected filters"
        },
        "progress_over_time": {
            "title": "Progress Over Time",
            "avg_score": "Average Score",
            "week": "Week",
            "month": "Month",
            "no_data": "No data for selected period"
        },
        "department_aggregation": {
            "title": "Department Comparison",
            "avg_score": "Average Score",
            "players": "Participants",
            "no_data": "No department data available for the selected filters"
        },
        "employee_comparison": {
            "title": "Employee Comparison",
            "subtitle": "Compare skill evaluations for 2-3 employees side by side",
            "select_players": "Select 2-3 participants to compare",
            "max_players": "Maximum 3 participants allowed"
        },
        "score_distribution": {
            "title": "Score Distribution",
            "subtitle": "Distribution of evaluation scores by competence or skill",
            "count": "Evaluations",
            "q1": "Q1",
            "median": "Median",
            "q3": "Q3",
            "average": "Average",
            "no_data": "No evaluation data available for the selected filters"
        },
        "evaluator_consistency": {
            "title": "Evaluator Consistency",
            "subtitle": "Correlation and average scores across evaluator types",
            "correlation": "Correlation Matrix",
            "correlation_method": "Pearson",
            "avg_by_type": "Average by Evaluator Type",
            "pair_details": "Pair Details",
            "corr_label": "Corr",
            "gap_label": "Gap",
            "shared_label": "Shared",
            "no_data": "Not enough evaluation data to compute consistency"
        },
        "engagement_dashboard": {
            "title": "Engagement Dashboard",
            "subtitle": "Track activity intensity and identify employees who need attention",
            "active_employees": "Active Employees",
            "avg_games_week": "Avg Sessions / Week",
            "inactive_employees": "Inactive Employees",
            "inactive_threshold_days": "Inactive threshold (days)",
            "days_inactive": "{days} days inactive",
            "last_game_date": "Last session: {date}",
            "no_games_yet": "No sessions yet",
            "no_inactive": "No inactive employees found"
        },
        "strengths_weaknesses": {
            "title": "Strengths & Weaknesses",
            "subtitle": "Your top 3 strongest and weakest skills",
            "strengths": "Strengths",
            "weaknesses": "Areas for Improvement",
            "no_data": "Not enough evaluation data yet"
        },
        "peer_percentile": {
            "title": "Peer Percentile",
            "subtitle": "Your rank by skill compared to peers in your organization",
            "top_percent": "Top {percent}%",
            "bottom_percent": "Bottom {percent}%",
            "no_data": "Not enough peer data to compute percentiles"
        },
        "evaluation_gap": {
            "title": "Self vs AI Evaluation Gap",
            "subtitle": "Compare your self-assessment with AI evaluation to discover blind spots",
            "self_assessment": "Self Assessment",
            "ai_evaluation": "AI Evaluation",
            "gap": "Gap",
            "skill": "Skill",
            "no_data": "No data available - both self and AI evaluations are required"
        },
        "improvement_velocity": {
            "title": "Improvement Velocity",
            "subtitle": "Score change comparing last 30 days vs previous 30 days",
            "no_data": "Not enough data to calculate improvement",
            "improved": "Improved",
            "declined": "Declined"
        },
        "activity_calendar": {
            "title": "Activity Calendar",
            "subtitle": "Daily session participation over the last 6 months",
            "current_streak": "Current Streak",
            "longest_streak": "Longest Streak",
            "total_games": "Total Sessions",
            "games_count": "{count} sessions",
            "no_activity": "No activity recorded in the last 6 months"
        },
        "session_history": {
            "title": "Session History",
            "subtitle": "Your recent sessions and results",
            "date": "Date",
            "scenario": "Scenario",
            "type": "Type",
            "score": "Score",
            "status": "Status",
            "types": {
                "player_vs_player": "Participant vs Participant",
                "player_vs_ai": "Participant vs AI",
                "training": "Training"
            },
            "statuses": {
                "time_scheduling": "Start time scheduling",
                "waiting_for_start": "Waiting for start",
                "missed": "Missed",
                "in_progress": "In progress",
                "protocol_approval": "Protocol approval",
                "failed": "Failed",
                "completed": "Completed"
            }
        }
    },
    "org_activity": {
        "title": "Org Activity",
        "empty": "No activity in this period",
        "search_placeholder": "Search organizations…",
        "chips": {
            "today": "Today",
            "week": "Week",
            "all": "All",
            "inactive": "Inactive ≥7d"
        },
        "sort": {
            "recent": "Most recent",
            "least_active": "Least active",
            "az": "A–Z"
        },
        "card": {
            "plays_in_7_days": "{count} plays in 7 days",
            "open_menu": "Open menu",
            "open_audit_log": "Open audit log"
        },
        "drawer": {
            "title": "Recent activity",
            "open_audit_log": "Open full audit log",
            "active_for": "Active {time} ago",
            "summary": "{games} games · {scenarios} scenarios · {ai_profiles} AI-profiles",
            "buckets": {
                "today": "Today",
                "yesterday": "Yesterday",
                "this_week": "This week",
                "older": "Older"
            }
        },
        "events": {
            "game_created": "Game played",
            "voice_session_created": "Voice session started",
            "scenario_created": "Scenario created",
            "scenario_updated": "Scenario updated",
            "ai_profile_created": "AI profile created",
            "profile_created": "New employee registered"
        }
    },
    "participant": {
        "upcoming_games": "Upcoming sessions",
        "for_rank_games": "To be rated"
    },
    "roles": {
        "player": "Participant",
        "admin": "SuperAdmin (system)",
        "scoped_admin": "Senior Administrator",
        "observer": "Observer",
        "captain": "Captain",
        "expert": "Expert",
        "lead_expert": "Senior Expert",
        "manager": "Manager",
        "support": "Support",
        "early_access": "Early access",
        "head": "Head",
        "candidate": "Candidate"
    },
    "user-status": {
        "active": "Active",
        "inactive": "Inactive",
        "pending": "Pending"
    },
    "pagination": {
        "showing": "showing",
        "to": "to",
        "of": "of",
        "entries": "entries"
    },
    "validator": {
        "required": "This field is required",
        "library": "File size must be less than 500MB",
        "email": "The Email field must be a valid email",
        "password": "Field must contain at least one uppercase, lowercase, special character and digit with min 8 chars",
        "confirm": "The Confirm Password field confirmation does not match",
        "at_least": "The field must contain at least",
        "items": "items",
        "number": "This field must be an integer",
        "is_odd": "This field must be even",
        "number_between": "Enter number between",
        "number_and": "and",
        "date_range_required": "Range required",
        "invalid_date_range": "Invalid range",
        "invalid_date_format": "Invalid date format",
        "start_date_after_end_date": "Date from must be before date to",
        "max_180_days": "Max 180 days"
    },
    "user": {
        "menu": {
            "settings": "Settings",
            "statistics": "Statistics",
            "logout": "Log out"
        }
    },
    "theme": {
        "system": "System",
        "light": "Light",
        "dark": "Dark"
    },
    "error": {
        "default": "Sorry, there was an error. Our specialists are already aware and will fix it as soon as possible.",
        "unauthorized": "Your session has expired.",
        "contact-support": "Sorry, there was an error. Please contact technical support",
        "forbidden": "Access denied"
    },
    "confirmation": {
        "sure": "Are you sure you want to delete the entry?",
        "sure_return_to_time_scheduling": "Are you sure you want to revert the session to the stage of start time coordination?",
        "sure_restore": "Are you sure you want to restore the entry?",
        "sure_mark_completed": "Are you sure you want to mark this session as completed?",
        "sure_mark_failed": "Mark the game as failed and permanently delete all evaluations and participant protocols?",
        "success": "Success!",
        "deleted": "Deleted",
        "failed_marked": "Game marked as failed",
        "restored": "Restored",
        "cancel": "Canceled",
        "yes": "Yes",
        "no": "No"
    },
    "dashboards": {
        "player": {
            "summary": {
                "welcome": "Welcome back",
                "progress": "Your overall progress",
                "stats": {
                    "minutes": "Minutes played",
                    "effectiveness": "Overall score",
                    "completed_games_count": "Completed sessions",
                    "total_games_count": "Total sessions"
                }
            },
            "cards": {
                "players_rating": {
                    "title": "Company ranking",
                    "player": "Participant",
                    "effectiveness": "Effectiveness"
                }
            }
        },
        "head": {
            "my_stats": "My statistics",
            "subordinates": "My subordinates",
            "subordinate_stats": "Subordinate statistics",
            "select_subordinate": "Select a subordinate to view their statistics",
            "no_subordinates": "No subordinates assigned"
        }
    },
    "chat-page": {
        "last_game": "Last session",
        "chats": "Chats",
        "no-chats": "No chats found",
        "contacts": "Contacts",
        "choose": "Choose contact",
        "send": "Send",
        "type": "Type your message...",
        "no-contacts": "No contacts found",
        "search": "Search...",
        "start_conversation": "Start conversation",
        "start_connecting": " Start connecting with the people by selecting one of the contact on left"
    },
    "scenarios-page": {
        "title": "Title",
        "export-docx": "Export .docx",
        "copy_title": "Copy scenario",
        "generate_ai_title": "AI Generate Scenario",
        "organization": "Company",
        "competence": "Competence",
        "actions": " ",
        "add": "Add scenario",
        "ai-generate": "AI Generate",
        "copy": "Copy scenario",
        "add_popup": "Add scenario",
        "delete": "Delete scenario",
        "edit": "Edit scenario",
        "edit_popup": "Edit scenario",
        "industries": [
            "FMCG/Retail",
            "Pharmaceuticals",
            "Banks and Fintech",
            "Hotels and Tourism",
            "IT Companies/SaaS",
            "Restaurant Business/HoReCa",
            "E-commerce/Marketplaces",
            "Manufacturing/Industry 4.0",
            "Logistics and T&L",
            "Telecom",
            "Education/EdTech",
            "Chemical industry",
            "Supply chain software",
            "Government/Non-profit Organizations"
        ],
        "case_types": [
            "Leadership and People-Management",
            "Recruitment and Personnel Assessment",
            "Sales and Customer Service",
            "Negotiations and Influence",
            "Conflict Management",
            "Strategy and Execution"
        ],
        "cases": [
            [
                "SMART/OKR Goal Setting",
                "Giving Developmental Feedback (SBI/COIN)",
                "Delegation",
                "GROW Coaching",
                "Performance Review",
                "Mentoring"
            ],
            [
                "Competency-Based Interview (CBI)",
                "Assessment/Assessment Center",
                "Onboarding Session"
            ],
            [
                "Classic Product/Service Sales",
                "Handling Objections",
                "Upsell/Cross-sell",
                "Complaint Handling",
                "M-channel Sales"
            ],
            [
                "Internal Corporate Budget/Resource Negotiations",
                "Client/Supplier Contract",
                "Crisis Negotiations"
            ],
            [
                "Interpersonal Team Conflict",
                "Manager-Subordinate",
                "Values/Ethics Conflict"
            ],
            [
                "Project Portfolio Prioritization",
                "Change Management",
                "Risk Analysis"
            ]
        ],
        "formats": [
            "1-1",
            "Teams"
        ],
        "labels": {
            "industry": "Industry",
            "case_type": "Case Type",
            "case": "Case",
            "format": "Format",
            "duration": "Duration (minutes)",
            "game_vs_ai": "Session vs AI",
            "level": "Level",
            "competence": "Competence",
            "description": "Scenario Description",
            "description_hint": "Optionally describe the scenario you want to generate (max 4000 characters)"
        },
        "generating_in_progress": "Generating scenario, please wait..."
    },
    "analytics-page": {
        "tours-page": {
            "tour": "Tour",
            "full_name": "Participant",
            "games_count": "Sessions",
            "team": "Team",
            "export": "Export",
            "effectiveness": "Effectiveness"
        }
    },
    "report-filters": {
        "department": "Department",
        "position": "Position",
        "employee": "Employee",
        "scenario": "Scenario",
        "competence": "Competence",
        "period": "Period",
        "reset": "Reset",
        "only-period-competence": "Only the period and competence filters apply"
    },
    "competencies-page": {
        "title": "Title",
        "export-docx": "Export .docx",
        "skills": "Skills",
        "text": "Text",
        "display_order": "Sort",
        "ai-assistant": "AI Assistant",
        "language": "Language",
        "department": "Department",
        "evaluation-format": "Evaluation format",
        "evaluation-format-skills": "Skill scores",
        "evaluation-format-checklist": "Binary checklist",
        "rubric": "Rubric",
        "evaluation-target": "Who are we evaluating?",
        "evaluation-both": "Both participants",
        "evaluation-team-a": "Only team A",
        "evaluation-both-tooltip": "Both participants are evaluated - suitable for negotiation scenarios",
        "evaluation-team-a-tooltip": "Only the leader is evaluated - feedback format",
        "actions": " ",
        "add": "Add competence",
        "add_popup": "Add competence",
        "delete": "Delete competence",
        "edit": "Edit competence",
        "edit_popup": "Edit competence"
    },
    "faq-page": {
        "title": "Questions",
        "question": "Question",
        "text": "Answer",
        "is_shared": "Available for all companies",
        "actions": " ",
        "add": "Add question",
        "add_popup": "Add question",
        "delete": "Delete question",
        "edit": "Edit question",
        "edit_popup": "Edit question",
        "visibility": "Visibility",
        "visible_to_all": "Visible to all users",
        "visible_to_managers": "Visible to managers only"
    },
    "ai-connectors-page": {
        "title": "AI Connectors",
        "is_shared": "Available for all organizations",
        "actions": " ",
        "add": "Add connector",
        "add_popup": "Add connector",
        "delete": "Delete connector",
        "edit": "Edit connector",
        "edit_popup": "Edit connector",
        "label": "Label",
        "provider": "Provider",
        "service": "Service",
        "organization": "Organization",
        "status": "Status",
        "region": "Region",
        "endpoint": "Endpoint",
        "secret": "Password/Key",
        "maxConcurrency": "Max Concurrency",
        "timeoutSec": "Timeout",
        "sortOrder": "Sort Order",
        "config": "Configuration",
        "modelPrimary": "Primary model",
        "modelLight": "Light model",
        "modelLightHint": "Falls back to the primary model when empty",
        "folderId": "Folder ID",
        "models": "Models",
        "is_default": "Default",
        "notes": "Notes"
    },
    "skills-page": {
        "title": "Title",
        "display_order": "Sort",
        "competence": "Competence",
        "text": "Indicators",
        "actions": " ",
        "add": "Add skill",
        "add_popup": "Add skill",
        "delete": "Delete skill",
        "edit": "Edit skill",
        "edit_popup": "Edit skill"
    },
    "departments-page": {
        "title": "Title",
        "actions": " ",
        "add": "Add department",
        "add_popup": "Add department",
        "delete": "Delete department",
        "edit": "Edit department",
        "edit_popup": "Edit department"
    },
    "tours-page": {
        "title": "Title",
        "actions": " ",
        "add": "Add tour",
        "add_popup": "Add tour",
        "delete": "Delete tour",
        "edit": "Edit tour",
        "edit_popup": "Edit tour"
    },
    "library-page": {
        "title": "Title",
        "text": "Description",
        "video": "Video",
        "courses": "Courses",
        "video_link_copy": "Copy link",
        "video_in_process": "Video is being processed...",
        "is_public": "Is public",
        "actions": " ",
        "add": "Add video",
        "add_popup": "Add video",
        "delete": "Delete video",
        "edit": "Edit video",
        "edit_popup": "Edit video"
    },
    "library-documents-page": {
        "title": "Title",
        "actions": " ",
        "add": "Add document",
        "add_popup": "Add document",
        "delete": "Delete document",
        "edit": "Edit document",
        "edit_popup": "Edit document",
        "file": "File"
    },
    "scorm-page": {
        "title": "Title",
        "actions": " ",
        "add": "Add course",
        "loading": "Course is loading...",
        "add_popup": "Add course",
        "delete": "Delete course",
        "edit": "Edit course",
        "edit_popup": "Edit course",
        "zip_file": "ZIP file"
    },
    "ai-assistants-page": {
        "external_id": "ID",
        "description": "Description",
        "actions": " ",
        "add": "Add AI assistant",
        "add_popup": "Add AI assistant",
        "delete": "Delete AI assistant",
        "edit": "Edit AI assistant",
        "edit_popup": "Edit AI assistant"
    },
    "ai-prompts-page": {
        "name": "Name",
        "content": "Content",
        "actions": " ",
        "add": "Add AI prompt",
        "add_popup": "Add AI prompt",
        "delete": "Delete AI prompt",
        "edit": "Edit AI prompt",
        "edit_popup": "Edit AI prompt",
        "key": "Slot key",
        "model": "Model",
        "updated_at": "Updated",
        "custom": "Custom",
        "description": "Description",
        "temperature": "Temperature",
        "top_p": "Top P",
        "reasoning_effort": "Reasoning effort",
        "reasoning_effort_default": "Default",
        "required_placeholders": "Required placeholders (must be present in the content)",
        "versions": "Version history",
        "no_versions": "No versions yet",
        "restore": "Restore",
        "restore_confirm": "Restore this version? Its content will become the current one.",
        "restored": "Version restored",
        "current_version": "Current",
        "author": "Author",
        "error": "Something went wrong.",
        "tab_system": "System",
        "tab_custom": "Custom",
        "system_hint": "System prompts are used by platform code. They cannot be deleted, but their content can be edited.",
        "custom_hint": "Custom prompts are attached to competencies and AI profiles as an evaluation prompt override.",
        "model_from_code": "set by code",
        "model_from_code_hint": "The model is chosen by the code that consumes the prompt; it is not stored in the prompt itself.",
        "used_by": "Used by",
        "used_by_value": "Competencies: {competencies}, AI profiles: {profiles}",
        "not_used": "Not used",
        "delete_blocked_hint": "Cannot delete: the prompt is used as an override. {usage}",
        "slot_description": {
            "game_eval_negotiation": "AI evaluation of PvP games: negotiation",
            "game_eval_feedback": "AI evaluation of PvP games: feedback",
            "game_eval_vs_ai": "AI evaluation of games vs AI (when the AI profile has no override)",
            "protocol_evaluation": "Filling the scenario protocol from a game-vs-AI transcript",
            "voice_agent": "System prompt for the voice AI interlocutor",
            "scenario_generation": "Scenario generation from description",
            "scenario_card_update": "Updating the scenario card from an AI description",
            "scenario_optimize": "Optimizing the AI description of a scenario",
            "skill_report_analysis": "Skill report: analysis step",
            "skill_report_recommendations": "Skill report: recommendations step"
        }
    },
    "evaluation-rubrics-page": {
        "name": "Name",
        "actions": " ",
        "add": "Add rubric",
        "add_popup": "Add rubric",
        "edit": "Edit rubric",
        "edit_popup": "Edit rubric",
        "delete": "Delete rubric",
        "updated_at": "Updated",
        "hint": "Rubrics define binary checklists used to evaluate games. Attach a rubric to a competency to switch it to checklist evaluation.",
        "used_by": "Used by",
        "used_by_value": "Competencies: {count}",
        "not_used": "Not used",
        "delete_blocked_hint": "Cannot delete: used by {count} competencies.",
        "criteria": "Criteria",
        "criterion_text": "Criterion",
        "criterion_category": "Category (optional)",
        "add_criterion": "Add criterion",
        "criteria_hint": "Drag to reorder. Group related criteria by giving them the same category.",
        "drag_to_reorder": "Drag to reorder",
        "no_criteria": "Add at least one criterion.",
        "versions": "Version history",
        "no_versions": "No versions yet",
        "criteria_count": "{count} criteria",
        "restore": "Restore",
        "restore_confirm": "Restore this version? It will become the current one.",
        "restored": "Version restored",
        "current_version": "Current",
        "author": "Author",
        "error": "Something went wrong."
    },
    "ai-profiles-page": {
        "name": "Name",
        "settings": "Settings",
        "temperature": "Fantasy",
        "demeanor": "Demeanor",
        "behavior": "Behavior, instructions",
        "background": "Biography",
        "style": "Style",
        "instructions": "Instructions",
        "supportive_phrases": "Supportive Phrases",
        "ai_assistant": "AI Assistant",
        "ai_starts_first": "AI Starts First",
        "first_phrase": "First Phrase",
        "closing_phrases": "Closing Phrases",
        "voice": "Voice",
        "expert_mode": "Expert Mode",
        "custom_demeanor_hint": "Current custom demeanor",
        "is_shared": "Available for all organizations",
        "voice_options": {
            "male": "Male",
            "female": "Female"
        },
        "demeanor_options": {
            "friendly": {
                "title": "Friendly",
                "description": "Easily approachable and pleasant"
            },
            "critical": {
                "title": "Critical",
                "description": "Frequently points out flaws and areas of improvement"
            },
            "empathetic": {
                "title": "Empathetic",
                "description": "Highly sensitive to others' feelings and emotions"
            },
            "enthusiastic": {
                "title": "Enthusiastic",
                "description": "Shows intense excitement and eagerness"
            },
            "analytical": {
                "title": "Analytical",
                "description": "Focuses on logic and detailed problem-solving"
            },
            "curious": {
                "title": "Curious",
                "description": "Eager to learn and ask questions"
            },
            "assertive": {
                "title": "Assertive",
                "description": "Confident and self-assured"
            },
            "blunt": {
                "title": "Blunt",
                "description": "Direct and to the point"
            },
            "skeptical": {
                "title": "Skeptical",
                "description": "Wary of new solutions and ideas"
            },
            "neutral": {
                "title": "Neutral",
                "description": "Balanced and objective in communication style"
            },
            "casual": {
                "title": "Casual",
                "description": "Relaxed and conversational in tone"
            }
        },
        "placeholders": {
            "name": "For example: Sergey (polite and friendly)",
            "demeanor": "For example: Friendly, polite and sociable...",
            "background": "For example: Was fired twice...",
            "behavior": "For example: Doesn't interrupt, actively listens...",
            "first_phrase": "For example: Good day! How is your mood?",
            "closing_phrases": "For example: We have almost no time left, so I suggest we quickly summarize our meeting."
        },
        "actions": " ",
        "add": "Add AI profile",
        "add_popup": "Add AI profile",
        "subtitle": "How the conversation partner looks and sounds in the session",
        "preview": {
            "title": "Preview",
            "unnamed": "Unnamed",
            "voice": "voice {name}",
            "defaultVoice": "default voice",
            "defaultPhoto": "Default photo",
            "listen": "Listen to voice",
            "defaultVoiceNotice": "The voice will be picked when the session starts, so it can't be previewed",
            "photoPlaceholder": "Your photo will appear here"
        },
        "delete": "Delete AI profile",
        "edit": "Edit AI profile",
        "edit_popup": "Edit AI profile",
        "avatar_hint": "avatar image",
        "avatar_save_first": "Save the profile first to enable avatar uploads",
        "avatar_requirements": "Max 1 MB • Recommended: 1536×1024 • Aspect ratio: 3:2",
        "max_characters": "Max {max} characters"
    },
    "games-page": {
        "game-with-ai": "Roleplay with AI",
        "organization": "Organization",
        "status": "Status",
        "failure_reasons": {
            "protocol_not_agreed": "Protocol was not agreed by participants",
            "protocol_approval_expired": "Protocol approval time expired",
            "annulled": "Session was annulled",
            "expired": "Session time expired",
            "assignment_changed": "Course assignment changed in the learning system"
        },
        "restore": "Restore",
        "play": "Play",
        "meetings_unavailable": "Video sessions between participants are temporarily unavailable. Please try again later.",
        "import": "Import",
        "scenario": "Scenario",
        "tour": "Tour",
        "game_types": {
            "classic": "Classic mode",
            "vs_ai": "Roleplay with AI",
            "uploaded_recording": "Recording"
        },
        "upload_recording": {
            "file": "Recording file",
            "file_hint": "Video or audio, up to 1 GB",
            "uploaded": "File uploaded",
            "file_too_large": "File exceeds 1 GB",
            "upload_error": "Failed to upload the file",
            "player": "Participant",
            "rate_both": "Evaluate both participants",
            "second_player": "Second participant",
            "open_session": "Open session"
        },
        "game_targets": {
            "user": "Participant",
            "position": "Position",
            "department": "Department"
        },
        "number": "Number",
        "start_up_to": "Start up to",
        "start_time": "Start time",
        "teamA": "Team A",
        "teamB": "Team B",
        "others": "Participants",
        "actions": " ",
        "edit_results": "Change results",
        "add": "Add session",
        "add_popup": "Add session",
        "delete": "Delete session",
        "edit": "Edit session",
        "edit_popup": "Edit session",
        "time_scheduling": "Start time scheduling",
        "return_to_time_scheduling": "Return to start time scheduling",
        "preparation": "Preparation for the session",
        "view_scenario": "View scenario",
        "protocol": "Protocol approval",
        "not_agreed": "Not agreed",
        "expert-accept": "Accept and proceed to evaluation",
        "expert-decline": "Decline",
        "hide_ai_results": "Hide AI results",
        "show_ai_results": "Show AI results",
        "mark_completed": "Mark as completed",
        "mark_failed": "Mark as failed",
        "popup": {
            "start_up_to": "Start up to",
            "target": "Who should the session be assigned to?",
            "custom_field_value": "Value of “{field}”",
            "target_preview_count": "Sessions to be created: {count}",
            "target_preview_empty": "No players match this target — no sessions will be created",
            "target_preview_limit_exceeded": "That is more than one assignment can create (at most {limit}). Reduce the slice, the number of cases or the number of copies",
            "copies_per_player": "Copies of each case per player",
            "position": "Position",
            "department": "Department",
            "scenario": "Scenario",
            "optional": "Optional, can be omitted",
            "protocol_time": "Protocol time",
            "protocol_time_hint": "Number between 1 and 1440",
            "preparation_time": "Preparation time",
            "preparation_time_hint": "In minutes",
            "game_duration": "Session duration",
            "game_duration_hint": "Number between 1 and 60",
            "is_team": "Scenario for teams",
            "is_camera_required": "Participant cameras are required",
            "is_self_rated": "Participants can rate themselves",
            "is_each_other_rated": "Participants can rate each other",
            "is_expert_rated": "Expert rate is available",
            "is_ai_rated": "AI rate is available",
            "show_results": "Show results",
            "automatically": "automatically",
            "manually": "manually",
            "is_public_hint": "Any observer will be able to connect",
            "is_public": "Public session",
            "team_a": "Team A",
            "team_b": "Team B",
            "player_a": "Participant A",
            "player_b": "Participant B",
            "expert": "Expert",
            "observers": "Observers",
            "tour": "Tour",
            "search": "Search...",
            "choose_players": "Choose participants",
            "choose_expert": "Choose expert",
            "choose_observers": "Choose observers",
            "choose_scenario": "Choose scenario",
            "choose_tour": "Choose tour",
            "expert_empty": "If not selected, the captain will be able to choose",
            "captain": "Captain",
            "": "",
            "protocol": {
                "title": "Protocol approval",
                "target": "Target",
                "await_approval": "Await opponent's approval",
                "await_proposal": "Await opponent's proposal",
                "questions": "Questions for your team",
                "questions_a": "Questions for team A",
                "questions_b": "Questions for team B",
                "not_agreed": "Did not agree",
                "not_agreed_confirm": "The session will end unsuccessfully and the results will not be counted. This action is irreversible.",
                "not_agreed_done": "The session has ended unsuccessfully."
            },
            "start_time": {
                "title": "Start time",
                "must_start_by": "Must start by"
            },
            "edit_results": {
                "title": "Change results"
            },
            "preparation": {
                "title": "Preparation for the session",
                "description": "Description",
                "description_team": "Team description",
                "notes": "Personal notes"
            },
            "import": {
                "download_example": "Download example",
                "title": "Sessions import",
                "button": "Start import",
                "label": "Excel file",
                "file_size_error": "File size should be less than 10 MB"
            },
            "create_multi_scenario_games_immediately": "All sessions will be created immediately",
            "create_multi_scenario_games_sequentially": "Sessions will be created sequentially (after successful completion of each)"
        }
    },
    "ai-game": {
        "title": "Roleplay with AI",
        "recording": "Recording",
        "ai": "AI",
        "you": "You",
        "ai_ready": "Ready",
        "camera_off": "Camera is off",
        "stop_game": "Stop",
        "start_game": "Start",
        "mic_permission": "Please grant microphone permissions in settings to start the session",
        "permissions_granted": "Permissions granted successfully!",
        "close": "Close",
        "microphone_required": "Please grant microphone permissions to start the session",
        "mic_required": "Turn on the microphone to start the session",
        "mic_not_detected": "No sound detected yet — try speaking or check your microphone",
        "permissions_needed": "Microphone access is required. Camera is optional",
        "dialog_history": "Dialog History",
        "agent": {
            "initializing": "Initializing...",
            "listening": "Listening",
            "thinking": "Thinking...",
            "speaking": "Speaking",
            "waiting": "Waiting for agent..."
        },
        "waiting_for_start": "Start the session to begin conversation",
        "grant_microphone": "Grant Microphone Access",
        "game_not_found": "Session Not Found",
        "game_not_found_desc": "Session with ID {id} could not be located.",
        "confirm": {
            "start_question": "Are you sure? The session can't be paused",
            "start_title": "Session Started",
            "start_success": "The session has been started successfully",
            "start_cancel_title": "Session Not Started",
            "start_cancel_msg": "The session start was cancelled",
            "end_question": "Are you sure? The session will be ended",
            "end_title": "Session Ended",
            "end_success": "The session has been ended successfully",
            "end_cancel_title": "Session Not Ended",
            "end_cancel_msg": "The session end was cancelled"
        },
        "voice": {
            "disconnected": "Disconnected",
            "connecting": "Connecting...",
            "connection_lost_permanently": "Connection lost. Session ended due to network issues.",
            "connected": "Connected to server",
            "connection_error": "Failed to connect to voice agent",
            "game_already_finished": "This game has already finished",
            "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
            "no_rooms_available": "No available rooms at the moment. Please try again later.",
            "preparing_recording": "Preparing recording, retrying in {seconds}s…",
            "recording_service_overloaded": "Recording service is overloaded. Please try again in a few minutes.",
            "session_quota_exhausted": "Your organization's session package is used up. Please contact your manager.",
            "connection_blocked": "Your network blocked the AI connection setup. Allow HTTPS (443) to the required domains, then try again.",
            "connection_blocked_signaling": "Your network's firewall or proxy is blocking the connection to the voice server. Try connecting from a different network or mobile hotspot.",
            "reconnecting": "Reconnecting...",
            "disconnect_dialog_title": "Connection Lost",
            "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
            "disconnect_retry": "Reconnect",
            "disconnect_finish": "Finish Session",
            "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
            "stop_failed": "Failed to stop the session",
            "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
            "mic_toggle_failed": "Failed to toggle microphone",
            "camera_toggle_failed": "Failed to toggle camera",
            "duplicate_tab_title": "Session Open in Another Tab",
            "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
            "duplicate_tab_back": "Go Back",
            "duplicate_tab_disconnect_title": "Opened in Another Tab",
            "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
        },
        "pending_chunks_title": "Unsaved Recording Data",
        "pending_chunks_desc": "There is unsaved recording data from a previous session. Would you like to resume uploading it?",
        "pending_chunks_uploaded": "All pending recordings have been uploaded successfully",
        "resume_upload": "Resume Upload",
        "skip": "Skip",
        "permissions_denied_safari": "Camera or microphone access was denied. Please go to Safari Settings > Websites > Camera/Microphone and allow access for this site.",
        "supported": "Browser supported"
    },
    "positions-page": {
        "title": "Title",
        "actions": " ",
        "add": "Add position",
        "add_popup": "Add position",
        "delete": "Delete position",
        "edit": "Edit position",
        "edit_popup": "Edit position"
    },
    "user-custom-fields-page": {
        "title": "Title",
        "type": "Type",
        "options_count": "Values",
        "actions": " ",
        "add": "Add field",
        "add_popup": "Add field",
        "delete": "Delete field",
        "delete_confirm": "Delete the field? The values stored for users will no longer be shown.",
        "edit": "Edit field",
        "edit_popup": "Edit field",
        "empty": "No custom fields yet",
        "error": "Failed to save the field",
        "type_text": "Text",
        "type_select": "Dictionary",
        "type_locked_hint": "The type cannot be changed after the field is created",
        "options": "Values",
        "options_hint": "The order of values here is the order in the dropdown",
        "options_required": "Add at least one value",
        "option_title": "Value",
        "option_add": "Add value",
        "option_delete": "Delete value",
        "option_delete_confirm": "Delete the value? It will be cleared for users who had it selected.",
        "option_move_up": "Move up",
        "option_move_down": "Move down"
    },
    "organizations-page": {
        "name": "Name",
        "host": "Host",
        "duel_limit": "Duel limit",
        "max_users": "Max users",
        "max_users_hint": "0 = unlimited",
        "max_vs_ai_games_per_scenario": "Max AI games per player per scenario",
        "max_vs_ai_games_per_scenario_hint": "Empty — no limit. Applies to self-service game creation by players",
        "employee_report_daily_limit": "Employee report limit per day",
        "employee_report_daily_limit_hint": "Empty — platform-wide limit. Applies to managers and heads",
        "employee_report_hourly_limit": "Employee report limit per hour",
        "employee_report_hourly_limit_hint": "Empty — platform-wide limit. Applies to managers and heads",
        "registration": "Registration open",
        "timezone": "Timezone",
        "locale": "Locale",
        "users_count": "Users",
        "actions": " ",
        "add": "Add organization",
        "add_popup": "Add organization",
        "delete": "Delete organization",
        "edit": "Edit organization",
        "edit_popup": "Edit organization",
        "available_languages": "Available languages",
        "show_game_numbers_for_player": "Show session numbers for participant",
        "allow_players_choose_expert": "Allow participants choose expert",
        "send_message": "Send message to managers",
        "message": "Message",
        "send": "Send",
        "clear_message": "Clear message",
        "current_message": "Current message",
        "two_factor_available": "Two-Factor Authentication Available",
        "two_factor_method": "Two-Factor Authentication Method",
        "two_factor_disabled": "Disabled",
        "two_factor_email": "Email",
        "two_factor_sms": "SMS",
        "hidden_menu_items": "Hidden menu items",
        "hide_ai_results": "Hide AI results",
        "hide_player_rating": "Hide company ranking from participants",
        "show_character_memory_to_player": "Show character memory to the player",
        "show_meeting_recap_to_player": "Show meeting recap to the player",
        "create_user_on_external_launch": "Create a user on the first request from an external system",
        "create_user_on_external_launch_hint": "When off, a learner the external system has not brought before is refused instead of getting a game. Every user created this way takes a seat in the subscription.",
        "allow_external_email_linking": "Allow linking an external user by email",
        "allow_external_email_linking_hint": "When on, an external person is matched to an existing employee if the external system reported their address from its own server. When off, such a launch is refused and no second user with that address is created."
    },
    "users-page": {
        "import": "Import",
        "user": "User",
        "roles": "Roles",
        "effectiveness": "Effectiveness",
        "department": "Department",
        "position": "Position",
        "status": "Status",
        "actions": " ",
        "add": "Add user",
        "add_popup": "New user",
        "last_login_at": "Last login",
        "delete": "Delete",
        "view": "View",
        "login": "Login",
        "message": "Message",
        "activate": "Activate",
        "deactivate": "Block",
        "edit_popup": "Edit user",
        "total_in_org": "Total in organization",
        "multi_role_note": "A person with several roles is counted in every badge",
        "filter_role": "Role",
        "all_roles": "All roles",
        "filter_activity": "Completed scenarios",
        "activity_played": "Yes",
        "activity_not_played": "No",
        "filter_activity_from": "Played since",
        "filter_last_login_from": "Login date",
        "filter_custom_field": "Custom field",
        "filter_custom_field_value": "Value of “{field}”",
        "last_login_never": "Never logged in",
        "last_login_since": "Logged in since",
        "cases_progress": "Cases completed",
        "cases_progress_value": "{completed} of {assigned}",
        "export": "Export",
        "popup": {
            "name": "First name",
            "last_name": "Last name",
            "patronymic": "Patronymic",
            "phone": "Phone",
            "timezone": "Timezone",
            "language": "Language",
            "country": "Country",
            "invalid_phone": "Wrong phone number",
            "department": "Department",
            "position": "Position",
            "effectiveness": "Effectiveness",
            "roles": "Roles",
            "organizations": "Organizations",
            "blocked": "Blocked",
            "is_active": "Is active",
            "email_verified": "Email is verified",
            "email_not_verified": "Email is not verified",
            "subordinates": "Subordinates",
            "search_subordinates": "Search participants...",
            "import": {
                "download_example": "Download example",
                "title": "Users import",
                "button": "Start import",
                "label": "Excel file",
                "marker_hint": "For a user that already exists, a blank cell keeps the current value and a dash (-) clears the field.",
                "result_title": "Import started",
                "result_created": "Will be created: {count}",
                "result_updated": "Will be updated: {count}",
                "result_skipped": "Skipped: {count}",
                "result_skipped_row": "Row {row}, {email}: {reason}",
                "result_truncated": "…and {count} more skipped rows"
            }
        }
    },
    "users-ranking-page": {
        "user": "User",
        "roles": "Roles",
        "effectiveness": "Effectiveness",
        "average-effectiveness": "Avg. per session",
        "sessions-count": "Sessions",
        "department": "Department",
        "position": "Position",
        "status": "Status",
        "export": "Export",
        "actions": " "
    },
    "user-detail": {
        "games_finished": "Sessions Finished",
        "not_found": "User with not found",
        "games_total": "Total",
        "username": "Username",
        "phone": "Phone",
        "status": "Status",
        "language": "Language",
        "timezone": "Timezone",
        "edit": "Edit",
        "department": "Department",
        "position": "Position",
        "activate": "Activate",
        "block": "Block",
        "account": {
            "title": "Account",
            "summary": {
                "title": "Summary",
                "games": "Sessions played",
                "place": "Place",
                "effectiveness": "Effectiveness",
                "time": "Time"
            }
        },
        "security": {
            "title": "Security",
            "change_password_title": "Change password",
            "change_password": "Change password",
            "new_password": "New password",
            "confirm_new_password": "Confirm new password",
            "password_requirements": "Password Requirements:",
            "password_requirements_1": "Minimum 8 characters long - the more, the better",
            "password_requirements_2": "At least one lowercase character",
            "password_requirements_3": "At least one number, symbol, or whitespace character"
        },
        "statistics": {
            "title": "Statistics"
        }
    },
    "game": {
        "character_memory": {
            "title": "What the character remembers",
            "subtitle": "The memory of past meetings the character brings into this game",
            "preview_subtitle": "The memory is not fixed yet — the character receives it the moment the game starts",
            "unavailable": "The previous meeting is unavailable to the character: they will start the conversation without remembering it.",
            "agreements": "Agreements",
            "player_commitments": "Player's commitments",
            "character_commitments": "Character's commitments",
            "open_issues": "Open issues",
            "facts": "Facts mentioned",
            "attitude": "Attitude towards the player",
            "evaluation_passed": "The evaluation results of that meeting were passed to the character",
            "evaluation_not_ready": "The evaluation of that meeting is not ready yet — the character receives it once it has been calculated.",
            "evaluation_hidden": "The evaluation texts are hidden by the organisation settings.",
            "overall_effectiveness": "Overall effectiveness",
            "outcome": {
                "deal": "Deal",
                "partial": "Partial",
                "no_deal": "No deal",
                "unclear": "Unclear"
            }
        },
        "meeting_recap": {
            "title": "Meeting recap",
            "outcome": "Outcome",
            "agreements": "Agreements",
            "player_commitments": "Player's commitments",
            "character_commitments": "Character's commitments",
            "open_issues": "Open issues",
            "facts": "Facts mentioned",
            "pending": "The meeting recap is still being prepared. Check back a little later.",
            "unavailable": "The recap of this meeting could not be built.",
            "none": "There is no recap for this game."
        },
        "title": "Session",
        "team": "Team",
        "expert": "Expert",
        "points": "points",
        "your_result": "Your result",
        "joined_at": "Joined:",
        "ended_at": "Completion date",
        "min": "min.",
        "duration": "Duration",
        "from_average": "from average",
        "ai_expert": "AI Expert",
        "ai_evaluation_in_progress": "AI evaluation in progress",
        "delete_ai_request": "Delete AI feedback",
        "ai_expert_refresh": "Refresh AI Results",
        "ai_expert_refresh_rejected": {
            "evaluation_not_completed": "AI results can't be refreshed right now: the AI evaluation is still in progress.",
            "answer_pending": "AI results can't be refreshed right now: the AI response hasn't arrived yet.",
            "recognition_pending": "AI results can't be refreshed right now: the recording is still being transcribed.",
            "recognition_has_no_speech": "No speech was recognized in the recording, so AI results can't be refreshed.",
            "recognition_has_too_little_speech": "There is almost no conversation between the participants in the recording, so no AI evaluation was performed.",
            "no_ai_evaluation": "This session no longer has an AI evaluation.",
            "game_evaluation_blocked": "The session did not take place or was annulled, so AI evaluation is not available."
        },
        "ai_expert_unavailable": {
            "recognition_has_no_speech": "No speech was recognized in the recording, so no AI evaluation was performed.",
            "recognition_has_too_little_speech": "There is almost no conversation between the participants in the recording, so no AI evaluation was performed.",
            "game_evaluation_blocked": "The session did not take place or was annulled, so AI evaluation is not available."
        },
        "ai_expert_refresh_failed": "Failed to refresh AI results.",
        "speaker_mapping": {
            "title": "Participants and voices",
            "voice": "Voice {number}",
            "unknown": "Not identified",
            "needs_review": "Check the participants",
            "needs_review_hint": "Participants may have been identified incorrectly: make sure the AI feedback went to the right people.",
            "failed": "Participants could not be identified automatically.",
            "unavailable": "The AI provider was unavailable; participants will be identified on the next evaluation.",
            "empty": "The transcript has no speech to identify participants by.",
            "corrected_manually": "Corrected manually",
            "under_reevaluation": "AI evaluation is running with these participants. Until it finishes, the page shows the previous results.",
            "confirm": "Participants are correct",
            "review": "Review",
            "dialog_hint": "Assign a participant to each voice. After saving, the AI feedback will be requested again.",
            "save": "Save",
            "cancel": "Cancel",
            "confirmed": "Participants confirmed",
            "fixed": "Participants fixed, AI feedback requested again",
            "action_failed": "Could not complete the action"
        },
        "ai_expert_created": "The session rating process has started. This will take a few minutes. You can leave the page, as we will send you a notification when the rating is available.",
        "expert_already_requested": "Rating has already been requested by another participant",
        "request_expert": "Request Expert",
        "assign_expert": "Assign Expert",
        "ai_process": "Please wait, processing",
        "analyzing_results": "Analyzing session results...",
        "complete_expert_request": "Complete evaluation",
        "tabs": {
            "description": {
                "title": "Scenario Description",
                "subtitle": "Session information and rules",
                "situation": "Situation",
                "your_role": "Your role",
                "player_role": "Player's role: {name}",
                "team_tab": "Team {team}",
                "empty": "This session has no descriptions.",
                "load_error": "Couldn't load the description. Please try again later."
            },
            "results": {
                "title": "Results",
                "effectiveness_summary": "Team effectiveness",
                "your_effectiveness": "Your effectiveness",
                "parameters_section": "Parameters",
                "parameter": "Parameter",
                "target": "Target",
                "coefficient": "Coefficient",
                "value": "Agreement",
                "points": "Points",
                "points_short": "points",
                "combinations": "Combinations",
                "combination_bonus": "Combination bonus",
                "questions": "Questions",
                "question": "Question",
                "answer": "Answer",
                "total": "Total"
            },
            "comments": {
                "title": "Video Analysis",
                "comments": "Comments",
                "no_comments": "No comments yet",
                "no_video": "Video unavailable",
                "video_processing": "Video is being processed...",
                "count": "comments",
                "delete": "Delete",
                "edit": "Edit",
                "popup": {
                    "add": "Add comment",
                    "edit": "Edit comment",
                    "comment": "Comment",
                    "player": "Participant",
                    "all": "To all"
                }
            },
            "feedback": {
                "title": "Session Evaluation",
                "no_feedback": "No ratings yet",
                "no_feedback_description": "Feedback for this session has not been added yet",
                "overall_score": "Overall Score",
                "skills_evaluated": "{count} skills evaluated",
                "no_comment": "No comment provided",
                "score_button": "Rate Participant",
                "player": "Participant",
                "author": "Author",
                "download": "Download video",
                "download_transcript": "Download transcript",
                "evaluators": {
                    "ai": "Expert",
                    "expert": "Expert",
                    "player": "Participant",
                    "manager": "Manager",
                    "head": "Head"
                },
                "popup": {
                    "score": {
                        "title": "Participant Evaluation",
                        "comment": "Comment",
                        "error": "You must evaluate all participant skills",
                        "save_error": "Could not save the evaluation. You may not have permission to evaluate this participant."
                    }
                }
            },
            "checklist": {
                "title": "Checklist",
                "total": "Items passed",
                "pass": "Pass",
                "fail": "Fail",
                "cannot_assess": "Cannot assess",
                "comment": "Overall comment",
                "category": "Category",
                "author": "Evaluator",
                "player": "Participant",
                "passed_of": "{passed} of {total}",
                "evidence": "Evidence",
                "rationale": "Rationale",
                "no_results": "No checklist evaluation yet",
                "no_results_description": "This session has not been evaluated against a checklist yet"
            }
        }
    },
    "scenario": {
        "steps": {
            "information": {
                "create_new_ai_profile": "Create New",
                "edit_ai_profile": "Edit",
                "delete_ai_profile": "Delete",
                "confirm_delete_ai_profile": "Are you sure you want to delete this AI profile?",
                "first_header": "Basic Settings",
                "second_header": "AI Player",
                "third_header": "Scenario Description",
                "is_public": "Public",
                "is_public_hint": "If enabled — scenario will be available for selection by participants.",
                "title": "Information",
                "subtitle": "Scenario basic data",
                "image": "scenario image",
                "field_title": "Title",
                "competence": "Competence",
                "description": "Description",
                "description_a": "Description for team A",
                "description_b": "Description for team B",
                "next_scenario_label": "Next Scenario",
                "next_scenario_placeholder": "Not selected",
                "next_scenario_hint": "After completing the session with this scenario, a session with the next scenario will be automatically created.",
                "memory_header": "Link to the next meeting",
                "memory_group_evaluation": "The next meeting's evaluation",
                "memory_group_character": "The next meeting's character",
                "memory_pass_to_next": "remembers this meeting",
                "memory_pass_to_next_hint": "The character of the next scenario opens the conversation as if with someone they already know: they receive a short summary of this meeting, the agreements, both sides' commitments, the open issues and the facts that were named. The recording and word-for-word quotes are not passed on. Turn this on when the next meeting continues this one: a second round of negotiations, a recurring one-on-one.",
                "memory_pass_evaluation_to_next": "knows this meeting's evaluation",
                "memory_pass_evaluation_to_next_hint": "Along with the memory, the character receives the skill feedback texts and the overall result of this meeting, so it can act as a coach who remembers what the player did well.",
                "memory_evaluate_next_with_agreements": "takes this meeting's agreements into account",
                "memory_evaluate_next_with_agreements_hint": "When evaluating the next meeting, the AI expert sees the agreements, both sides' commitments and the open issues from this one, and can check whether the player kept their word. Scores and evaluation texts from the previous meeting are not passed on, so they cannot pull the new score towards them.",
                "ai_profile": "AI Profile",
                "ai_profile_placeholder": "For AI matches only",
                "ai_description": "AI Description",
                "optimize_ai_description": "Optimize with AI",
                "optimizing_in_progress": "AI is optimizing the description. Please wait...",
                "optimize_error": "Failed to optimize the description. Please try again.",
                "ai_description_hint": "Writing an effective AI prompt requires experience. A poorly written prompt may lead to unpredictable scenario behavior. If you're unsure, use the \"Optimize with AI\" button, try the scenario generation feature, or contact your manager for assistance.",
                "knowledge_base_header": "Knowledge Base",
                "knowledge_base_documents": "Knowledge Base Documents",
                "knowledge_base_documents_hint": "Attach documents to provide context for AI player",
                "knowledge_base_no_documents": "No documents available. Upload documents on the \"Knowledge Base\" page.",
                "knowledge_base_chunks": "{count} chunks",
                "knowledge_base_purpose_voice": "AI session",
                "knowledge_base_purpose_eval": "Evaluation"
            },
            "settings": {
                "title": "Settings",
                "subtitle": "Scenario configuration",
                "min_players": "Min participants",
                "min_players_hint": "Number between 2 and 20",
                "max_players": "Max participants",
                "max_players_hint": "Number between 2 and 20",
                "protocol_time": "Protocol time (min)",
                "protocol_time_hint": "Number between 1 and 1440",
                "preparation_time": "Preparation time (min)",
                "preparation_time_hint": "Number between 0 and 1440. 0 - the description is immediately visible",
                "game_duration": "Session duration (min)",
                "game_duration_hint": "Number between 1 and 60",
                "is_team": "Scenario for teams",
                "is_camera_required": "Participant cameras are required",
                "is_self_rated": "Participants can rate themselves",
                "is_each_other_rated": "Participants can rate each other",
                "is_expert_rated": "Expert rate is available",
                "is_ai_rated": "AI rate is available",
                "show_results": "Show results",
                "automatically": "automatically",
                "manually": "manually"
            },
            "parameters": {
                "title": "Parameters",
                "subtitle": "Participant's parameters",
                "field_title": "Title",
                "team_a": "Team A",
                "team_b": "Team B",
                "player_a": "Participant A",
                "player_b": "Participant B",
                "points": "Points",
                "ratio": "Ratio",
                "add": "Add parameter"
            },
            "questions": {
                "title": "Questions",
                "subtitle": "Questions for participants",
                "question": "Question",
                "team": "Team",
                "team_placeholder": "Select Team",
                "answers": "Answers",
                "points": "Points",
                "select_answers": "Select answers",
                "add_combination": "Add combination",
                "add_question": "Add question"
            },
            "next": "Next",
            "previous": "Previous",
            "save": "Save"
        },
        "saved": "Scenario saved",
        "to_list": "Back to list",
        "add_detail": "Add scenario",
        "edit_detail": "Edit scenario"
    },
    "notifications": {
        "title": "Notifications",
        "mark_unread": "Mark all as unread",
        "mark_read": "Mark all as read",
        "delete_all": "Delete all",
        "no_new": "No notifications found",
        "system": "System",
        "evaluation": {
            "ready": {
                "subject": "Session #:gameNumber Evaluation",
                "text": "The session has been evaluated by an expert"
            }
        },
        "game": {
            "created": {
                "game_assigned": "You have a session assigned",
                "role": "Role:"
            },
            "proposal": {
                "subject": "Coordination of session time",
                "time": "Time:",
                "description": "Please confirm or propose your own option"
            },
            "agreed": {
                "subject": "Session time agreed upon",
                "time": "Time:",
                "description": "The description and preparation options will be available :preparationTime minutes before the start",
                "description_zero": "You can now review the scenario description and prepare"
            },
            "preparation": {
                "subject": "Preparation for the session",
                "text": "Session preparation is available."
            },
            "started": {
                "subject": "Session #:gameNumber has begun",
                "text": "Join!"
            },
            "missed": {
                "subject": "The session #:gameNumber is missed",
                "text": "Sorry, you missed the session"
            },
            "completed": {
                "subject": "Session #:gameNumber completed",
                "text": "Successful session"
            },
            "failed": {
                "subject": "Session #:gameNumber failed",
                "text": "Completed unsuccessfully"
            },
            "results": {
                "proposed": {
                    "subject": "Session protocol #:gameNumber agreed upon",
                    "text": "Agreement available"
                },
                "declined": {
                    "subject": "Session protocol #:gameNumber rejected",
                    "text": "Proposal rejected"
                },
                "not_agreed": {
                    "subject": "Session #:gameNumber: the parties did not agree",
                    "text": "The opposing captain marked that the parties did not agree. The session ended unsuccessfully and the results were not counted."
                }
            },
            "meeting": {
                "ended-player": {
                    "subject": "Session Meeting #:gameNumber Concluded",
                    "text": "Please wait for the results."
                },
                "ended-captain": {
                    "subject": "Session Meeting #:gameNumber Concluded",
                    "text_fill": "Please fill out the protocol.",
                    "text_wait": "Please wait for the protocol to be completed.",
                    "protocol_time": "Protocol time(minutes): :protocolTime"
                }
            }
        }
    },
    "profile": {
        "avatar_allowed": "Allowed JPG, GIF or PNG. Max size of 2MB",
        "avatar_label_choose": "Choose",
        "avatar_label_your_avatar": "your avatar",
        "name": "First name",
        "last_name": "Last name",
        "patronymic": "Patronymic",
        "phone": "Phone",
        "timezone": "Timezone",
        "language": "Language",
        "country": "Country",
        "invalid_phone": "Wrong phone number",
        "save_changes": "Save changes",
        "account": "Account",
        "security": "Security",
        "statistics": "Statistics",
        "notifications": "Notifications",
        "change_password_title": "Change password",
        "change_password": "Change password",
        "current_password": "Current password",
        "new_password": "New password",
        "confirm_new_password": "Confirm new password",
        "password_requirements": "Password Requirements:",
        "password_requirements_1": "Minimum 8 characters long - the more, the better",
        "password_requirements_2": "At least one lowercase character",
        "password_requirements_3": "At least one number, symbol, or whitespace character",
        "two_factor_title": "Two-Factor Authentication",
        "two_factor_description": "Add an extra layer of security to your account",
        "two_factor_org_enforced": "Two-factor authentication is enforced by your organization",
        "two_factor_method": "Authentication Method",
        "two_factor_disabled": "Disabled",
        "two_factor_email": "Email",
        "two_factor_sms": "SMS",
        "two_factor_save": "Save 2FA Settings"
    },
    "auth": {
        "password": "Password",
        "new_password": "New password",
        "remember": "Remember me",
        "timezone": "Timezone",
        "forgot": "Forgot Password",
        "login": "Login",
        "login_title": "Login",
        "new_password_title": "Change password",
        "change_password": "Save",
        "country": "Country",
        "invalid_phone": "Wrong phone number",
        "privacy_policy_title": "Privacy Policy",
        "privacy_policy_text": "Privacy policy text...",
        "first_time": "New on our platform?",
        "registration": "Create an account",
        "forgot_title": "Forgot password?",
        "forgot_description": "Enter your email and we'll send you instructions to reset your password",
        "send_reset_link": "Send Reset Link ",
        "back_to_login": "Back to login",
        "register": "Sign Up",
        "name": "First name",
        "last_name": "Last name",
        "patronymic": "Patronymic",
        "phone": "Phone",
        "enter_password": "Enter Password",
        "confirm_password": "Confirm Password",
        "not_first_time": "Already have an account?",
        "agree_too": "I agree to",
        "privacy_policy": "privacy policy & terms",
        "accept": " I accept ",
        "password_validation": "Field must contain at least one uppercase, lowercase, special character and digit with min 8 chars",
        "password_confirm_error": "The Confirm Password field confirmation does not match",
        "set_password": "Set New Password",
        "reset_password": "Reset Password",
        "for": "for",
        "sign_in_to_for": "Sign in to {app} for {org}",
        "registration_title": "Registration",
        "verify_title": "Email confirmation",
        "verify_head": "Verify your email",
        "verify_description": "Account activation link sent to your email address. Please follow the link inside to continue.",
        "verify_new_link": "A new verification link has been sent to the email address you provided during registration.",
        "verify_send": "Resend Verification Email",
        "verify_spam": "You have made too many requests, please try again in a minute",
        "verify_logout": "Log Out",
        "two_factor_title": "Two-Factor Authentication",
        "two_factor_description_email": "We've sent a verification code to your email address. Please enter the code below.",
        "two_factor_description_sms": "We've sent a verification code to your phone number. Please enter the code below.",
        "two_factor_code_label": "Verification Code",
        "two_factor_code_placeholder": "Enter 6-digit code",
        "two_factor_verify": "Verify",
        "two_factor_resend": "Resend Code",
        "two_factor_resend_success": "A new code has been sent",
        "two_factor_back": "Back to Login"
    },
    "filepond": {
        "upload": "Upload",
        "upload_complete": "Upload complete",
        "uploading": "Uploading",
        "loading": "Loading",
        "tap_to_cancel": "tap to cancel",
        "tap_to_undo": "tap to undo",
        "upload_aborted": "Upload cancelled",
        "file_too_large": "File is too large"
    },
    "text-editor": {
        "image": "Simply drag and drop your image in editor"
    },
    "webrtc": {
        "ready_to_start": "Ready to start",
        "connected": "Connected - Speak now!",
        "connection_lost": "Connection lost. Please try again."
    },
    "device_settings": {
        "title": "Audio & Video Device Settings",
        "speaker": "Speaker/Audio Output",
        "refresh_devices": "Refresh Devices",
        "speaker_switch_unsupported": "Speaker switching is not supported in this browser"
    },
    "device_setup": {
        "mic_level": "Mic Level",
        "mic_on": "On",
        "mic_off": "Off",
        "cam_on": "On",
        "cam_off": "Off"
    },
    "device_test": {
        "title": "Test Audio Devices",
        "speaker_test": "Speaker Test",
        "speaker_hint": "Click the button to play test sounds through your selected speaker",
        "play_sound": "Play Test Sound",
        "playing": "Playing...",
        "speaker_success": "Sound Played ✓",
        "mic_test": "Microphone Test",
        "mic_hint": "Click the button and speak into your microphone to test if it's working",
        "volume_level": "Volume Level",
        "speak_now": "Speak now...",
        "seconds_short": "s",
        "start_mic_test": "Test Microphone",
        "testing": "Testing...",
        "test_again": "Test Again",
        "mic_success": "Microphone is working correctly!",
        "mic_fail": "Microphone issue detected",
        "mic_fail_hint": "No sound was detected. Please check that your microphone is connected, not muted, and selected correctly in the settings."
    },
    "ai_assistant_types": {
        "type": "Type",
        "negotiation": "Negotiation",
        "feedback": "Feedback",
        "ai_profile": "AI Session"
    },
    "Login": "Login",
    "UI Elements": "UI Elements",
    "Forms & Tables": "Forms & Tables",
    "Welcome": "Welcome",
    "Pages": "Pages",
    "Charts & Maps": "Charts & Maps",
    "Others": "Others",
    "Typography": "Typography",
    "Cards": "Cards",
    "Basic": "Basic",
    "Advance": "Advance",
    "Widgets": "Widgets",
    "Components": "Components",
    "Alert": "Alert",
    "Close Alert": "Close Alert",
    "Avatar": "Avatar",
    "Badge": "Badge",
    "Button": "Button",
    "Calendar": "Calendar",
    "Image": "Image",
    "Pagination": "Pagination",
    "Progress Circular": "Progress Circular",
    "Progress Linear": "Progress Linear",
    "Autocomplete": "Autocomplete",
    "Tooltip": "Tooltip",
    "Slider": "Slider",
    "Date Time Picker": "Date Time Picker",
    "Select": "Select",
    "Switch": "Switch",
    "Checkbox": "Checkbox",
    "Radio": "Radio",
    "Textarea": "Textarea",
    "Rating": "Rating",
    "File Input": "File Input",
    "Otp Input": "Otp Input",
    "Form Layout": "Form Layout",
    "Form Validation": "Form Validation",
    "Charts": "Charts",
    "Apex Chart": "Apex Chart",
    "Chartjs": "Chartjs",
    "Account Settings": "Account Settings",
    "User Profile": "User Profile",
    "FAQ": "FAQ",
    "Dialog Examples": "Dialog Examples",
    "Pricing": "Pricing",
    "List": "List",
    "Edit": "Edit",
    "Nav Levels": "Nav Levels",
    "Level 2.1": "Level 2.1",
    "Level 2.2": "Level 2.2",
    "Level 3.1": "Level 3.1",
    "Level 3.2": "Level 3.2",
    "Raise Support": "Raise Support",
    "Documentation": "Documentation",
    "Dashboards": "Dashboards",
    "Analytics": "Analytics",
    "Apps & Pages": "Apps & Pages",
    "Email": "Email",
    "Chat": "Chat",
    "Invoice": "Invoice",
    "Preview": "Preview",
    "Add": "Add",
    "User": "User",
    "View": "View",
    "Login v1": "Login v1",
    "Login v2": "Login v2",
    "Register v1": "Register v1",
    "Register v2": "Register v2",
    "Register": "Register",
    "Forget Password v1": "Forget Password v1",
    "Forget Password v2": "Forget Password v2",
    "Forgot Password v1": "Forgot Password v1",
    "Forgot Password v2": "Forgot Password v2",
    "Forgot Password": "Forgot Password",
    "Reset Password v1": "Reset Password v1",
    "Reset Password v2": "Reset Password v2",
    "Reset Password": "Reset Password",
    "Miscellaneous": "Miscellaneous",
    "Coming Soon": "Coming Soon",
    "Not Authorized": "Not Authorized",
    "Under Maintenance": "Under Maintenance",
    "Error": "Error",
    "Statistics": "Statistics",
    "Actions": "Actions",
    "Access Control": "Access Control",
    "User Interface": "User Interface",
    "CRM": "CRM",
    "eCommerce": "eCommerce",
    "Icons": "Icons",
    "Chip": "Chip",
    "Dialog": "Dialog",
    "Expansion Panel": "Expansion Panel",
    "Combobox": "Combobox",
    "Textfield": "Textfield",
    "Range Slider": "Range Slider",
    "Menu": "Menu",
    "Snackbar": "Snackbar",
    "Tabs": "Tabs",
    "Form Elements": "Form Elements",
    "Form Layouts": "Form Layouts",
    "Authentication": "Authentication",
    "Page Not Found - 404": "Page Not Found - 404",
    "Not Authorized - 401": "Not Authorized - 401",
    "Server Error - 500": "Server Error - 500",
    "2": "2",
    "Forms": "Forms",
    "Timeline": "Timeline",
    "Disabled Menu": "Disabled Menu",
    "Help Center": "Help Center",
    "Verify Email": "Verify Email",
    "Verify Email v1": "Verify Email v1",
    "Verify Email v2": "Verify Email v2",
    "Two Steps": "Two Steps",
    "Two Steps v1": "Two Steps v1",
    "Two Steps v2": "Two Steps v2",
    "Custom Input": "Custom Input",
    "Extensions": "Extensions",
    "Tour": "Tour",
    "Register Multi-Steps": "Register Multi-Steps",
    "Wizard Examples": "Wizard Examples",
    "Checkout": "Checkout",
    "Create Deal": "Create Deal",
    "Property Listing": "Property Listing",
    "Roles & Permissions": "Roles & Permissions",
    "Roles": "Roles",
    "Simple Table": "Simple Table",
    "Tables": "Tables",
    "Data Table": "Data Table",
    "Permissions": "Permissions",
    "Apps": "Apps",
    "Misc": "Misc",
    "Wizard Pages": "Wizard Pages",
    "Form Wizard": "Form Wizard",
    "Numbered": "Numbered",
    "3": "3",
    "ecommerce": "ecommerce",
    "Ecommerce": "Ecommerce",
    "Editors": "Editors",
    "Front Pages": "Front Pages",
    "Landing": "Landing",
    "checkout": "checkout",
    "Payment": "Payment",
    "Swiper": "Swiper",
    "Product": "Product",
    "Category": "Category",
    "Order": "Order",
    "Details": "Details",
    "Customer": "Customer",
    "Manage Review": "Manage Review",
    "Referrals": "Referrals",
    "Settings": "Settings",
    "Overview": "Overview",
    "My Course": "My Course",
    "Course Details": "Course Details",
    "Academy": "Academy",
    "Logistics": "Logistics",
    "Dashboard": "Dashboard",
    "Fleet": "Fleet",
    "5": "5",
    "10": "10",
    "20": "20",
    "25": "25",
    "50": "50",
    "100": "100",
    "maintenance": "Maintenance",
    "maintenance-page": {
        "title": "Maintenance Settings",
        "notification_section": "Global Notification",
        "notification_placeholder": "Enter notification message for all users",
        "notification_hint": "This message will be shown to all authenticated users as a warning notification",
        "games_section": "Session Blocking",
        "games_blocked_label": "Block new sessions",
        "games_blocked_hint": "When enabled, users cannot create or start new sessions. Existing sessions can still be re-joined.",
        "save": "Save",
        "clear": "Clear",
        "clear_confirm": "Are you sure you want to clear the notification?",
        "last_updated": "Last updated",
        "updated_by": "by",
        "games_blocked_message": "We apologize for the inconvenience. The platform is currently undergoing maintenance. Sessions are temporarily unavailable."
    },
    "$vuetify": {
        "badge": "Badge",
        "noDataText": "No data available",
        "close": "Close",
        "open": "open",
        "carousel": {
            "ariaLabel": {
                "delimiter": "delimiter"
            }
        },
        "dataFooter": {
            "itemsPerPageText": "Items per page:",
            "itemsPerPageAll": "All",
            "pageText": "{0}-{1} of {2}",
            "firstPage": "First Page",
            "prevPage": "Previous Page",
            "nextPage": "Next Page",
            "lastPage": "Last Page"
        },
        "pagination": {
            "ariaLabel": {
                "root": "root",
                "previous": "previous",
                "next": "next",
                "first": "first",
                "last": "last",
                "currentPage": "currentPage",
                "page": "page"
            }
        },
        "input": {
            "clear": "clear",
            "appendAction": "appendAction",
            "prependAction": "prependAction",
            "counterSize": "counterSize",
            "otp": "otp"
        },
        "fileInput": {
            "counterSize": "counterSize"
        },
        "rating": {
            "ariaLabel": {
                "item": "item"
            }
        }
    },
    "subscription-plans": "Subscription Plans",
    "organization-subscriptions": "Organization Subscriptions",
    "subscription-plans-page": {
        "name": "Name",
        "description": "Description",
        "period": "Period",
        "grace_days": "Grace Days",
        "features": "Features",
        "charges": "Charges",
        "actions": " ",
        "add": "Add Plan",
        "add_popup": "Add Plan",
        "edit": "Edit Plan",
        "edit_popup": "Edit Plan",
        "delete": "Delete Plan",
        "delete_confirm": "Are you sure you want to delete this plan?",
        "monthly": "Monthly",
        "yearly": "Yearly",
        "permanent": "Permanent",
        "regular_games": "Regular Sessions",
        "ai_games": "AI Sessions",
        "any_games": "Any Sessions",
        "ai_chat_messages": "AI Chat Messages",
        "organization": "Organization",
        "global_plan": "Global",
        "periodicity": "Periodicity",
        "min_zero": "Must be >= 0",
        "min_one": "Must be >= 1"
    },
    "organization-subscriptions-page": {
        "organization": "Organization",
        "host": "Host",
        "current_plan": "Current Plan",
        "status": "Status",
        "expires_at": "Expires At",
        "actions": " ",
        "assign_plan": "Assign Plan",
        "switch_plan": "Switch Plan",
        "cancel_subscription": "Cancel Subscription",
        "renew_subscription": "Renew Subscription",
        "cancel_confirm": "Are you sure you want to cancel this subscription?",
        "renew_confirm": "Are you sure you want to renew this subscription?",
        "no_plan": "No plan",
        "active": "Active",
        "cancelled": "Cancelled",
        "expired": "Expired",
        "immediately": "Switch immediately",
        "view_usage": "View Usage",
        "usage": "Usage",
        "used_of": "{used} of {limit}",
        "add_ticket": "Add Ticket",
        "initial_consumption": "Initial Consumption",
        "feature": "Feature",
        "charges": "Charges",
        "expired_at_optional": "Expiration Date (optional)",
        "active_tickets": "Active Tickets",
        "no_expiry": "No expiry",
        "tickets_only": "Tickets",
        "revoke_ticket": "Revoke",
        "revoke_ticket_confirm": "Are you sure you want to revoke this ticket?",
        "deduct": "Deduct",
        "deduct_amount": "Amount",
        "deduct_confirm": "Deduct usage"
    },
    "api-tokens": "API Tokens",
    "api-tokens-page": {
        "select_user": "User",
        "select_user_hint": "Select a user to view and manage their API tokens.",
        "no_users_found": "No users found",
        "no_tokens": "This user has no API tokens.",
        "token_name": "Name",
        "abilities": "Abilities",
        "ability": "Ability",
        "created_at": "Created At",
        "last_used_at": "Last Used At",
        "expires_at": "Expires At",
        "actions": " ",
        "issue_token": "Issue Token",
        "issue": "Issue",
        "issue_failed": "Failed to issue token",
        "token": "Token",
        "plaintext_warning": "Copy this token now — it will not be shown again.",
        "revoke": "Revoke",
        "revoke_confirm": "Are you sure you want to revoke this token? Integrations using it will stop working."
    },
    "subscription": {
        "current_plan": "Current Plan",
        "expires_at": "Expires: {date}",
        "no_active_plan": "No active subscription plan",
        "quota_warning": "Low quota remaining",
        "regular_games": "Regular Sessions",
        "ai_games": "AI Sessions",
        "any_games": "Any Sessions",
        "ai_chat_messages": "AI Chat Messages",
        "used_of": "{used} of {limit}",
        "remaining": "{count} remaining",
        "quota_exceeded": "Feature quota exceeded",
        "tickets_only": "Credit Packages",
        "session_package": "Session package",
        "games_available": "Sessions",
        "users": "Users",
        "active_users": "Active users",
        "active_tickets": "Credit Packages",
        "ticket_charges": "{charges} credits",
        "ticket_no_expiry": "No expiry",
        "unlimited": "Unlimited",
        "no_game_limits": "No restrictions on the number of sessions"
    },
    "knowledge-base-page": {
        "title": "Knowledge Base",
        "upload": "Upload Document",
        "search-placeholder": "Search by title...",
        "filter-status": "Status",
        "confirm-delete": "Are you sure you want to delete this document? All related chunks will be removed.",
        "no-documents": "No documents available",
        "status": {
            "processing": "Processing",
            "ready": "Ready",
            "failed": "Error"
        },
        "headers": {
            "title": "Title",
            "type": "Type",
            "size": "Size",
            "chunks": "Chunks",
            "status": "Status",
            "created": "Upload Date",
            "actions": "Actions"
        },
        "upload-dialog": {
            "title": "Upload Document",
            "name": "Title",
            "file": "File",
            "hint": "PDF, DOCX, TXT, CSV, XLSX (max 10 MB)",
            "submit": "Upload"
        },
        "retry-success": "Document sent for reprocessing",
        "delete-success": "Document deleted",
        "upload-success": "Document uploaded",
        "provider-unsupported": "The knowledge base is not available with your organization's current AI provider."
    },
    "candidate-page": {
        "document_title": "Interview",
        "greeting": "Hello, {name}!",
        "intro_lead": "{organization} invites you to an interview with a virtual counterpart for the «{vacancy}» role.",
        "duration": "The interview takes about {minutes} min.",
        "requirements_title": "What you will need",
        "requirement_mic": "A working microphone, ideally a headset",
        "requirement_camera_required": "A camera turned on: it is required for this interview",
        "requirement_camera_optional": "A camera is optional, but the conversation feels more natural with it",
        "requirement_browser": "A computer with an up-to-date Chrome, Edge or Safari",
        "requirement_network": "A stable connection and a quiet place where nobody interrupts you",
        "continue": "Continue",
        "consent": {
            "accept": "I have read the text and consent to the processing of my personal data",
            "back": "Back",
            "start": "Start the interview"
        },
        "terminal": {
            "finished": {
                "title": "Thank you!",
                "text": "The interview is over and the result has been sent to the recruiter — they will get in touch with you. You can close this page."
            },
            "already_completed": {
                "title": "Interview already completed",
                "text": "This link has already been used for a completed interview. Contact the recruiter if you need to take it again."
            },
            "not_found": {
                "title": "Link not found",
                "text": "The address may contain a typo, or the link is no longer valid. Check the recruiter's email or contact them."
            },
            "session_conflict": {
                "title": "You are signed in to another account",
                "text": "Sign out of the current account or open the link in a private browser window."
            },
            "link_revoked": {
                "title": "Access to this link is closed",
                "text": "The recruiter has revoked this link. Contact them to get a new one."
            },
            "link_expired": {
                "title": "The link has expired",
                "text": "Contact the recruiter so they can issue a new link."
            },
            "attempts_exhausted": {
                "title": "No attempts left",
                "text": "All attempts available for this link have been used. Contact the recruiter."
            },
            "unavailable": {
                "title": "Cannot start right now",
                "text": "Try again later or contact the recruiter."
            },
            "rate_limited": {
                "title": "Too many attempts",
                "text": "Wait a minute and reload the page."
            },
            "aborted": {
                "title": "The interview did not start",
                "text": "Reload the page and try again. If that does not help, contact the recruiter."
            },
            "generic": {
                "title": "Something went wrong",
                "text": "Reload the page and try again. If that does not help, contact the recruiter."
            }
        }
    },
    "recruiting-page": {
        "title": "Recruiting",
        "create": "New vacancy",
        "edit": "Edit vacancy",
        "empty": "No vacancies yet",
        "load_error": "Failed to load the vacancy list",
        "retry": "Retry",
        "back": "Back to vacancies",
        "open": "Candidates",
        "archive": "Archive",
        "no_expiry": "No expiry",
        "confirm_archive": "Archive this vacancy? You will no longer be able to issue links for it.",
        "headers": {
            "title": "Vacancy",
            "scenario": "Scenario",
            "status": "Status",
            "expires_at": "Valid until",
            "actions": "Actions"
        },
        "status": {
            "draft": "Draft",
            "active": "Active",
            "archived": "Archived"
        },
        "dialog": {
            "title_label": "Vacancy title",
            "scenario_label": "Interview scenario",
            "scenario_placeholder": "Pick a scenario for the AI interview",
            "scenario_hint": "Only scenarios suitable for a game vs AI are listed",
            "status_label": "Status",
            "expires_label": "Valid until",
            "expires_hint": "Leave empty for no expiry",
            "save": "Save",
            "cancel": "Cancel"
        },
        "messages": {
            "created": "Vacancy created",
            "updated": "Vacancy updated",
            "archived": "Vacancy archived",
            "revoked": "Link revoked",
            "attempt_granted": "One more attempt granted",
            "copied": "Link copied",
            "error": "Something went wrong"
        },
        "candidates": {
            "title": "Candidates",
            "empty": "No links have been issued for this vacancy yet",
            "load_error": "Failed to load the candidate list",
            "issue": "Issue a link",
            "import": "Import from a file",
            "expired": "Expired",
            "no_games": "Interview not started",
            "attempts": "{used} of {allowed}",
            "revoke": "Revoke the link",
            "extra_attempt": "Grant one more attempt",
            "open_result": "Open the interview result",
            "confirm_revoke": "Revoke this candidate link? Access is lost immediately, including an interview in progress.",
            "confirm_extra_attempt": "Grant this candidate one more attempt?",
            "headers": {
                "candidate": "Candidate",
                "link_status": "Link",
                "invite": "Invitation",
                "game_status": "Interview",
                "attempts": "Attempts",
                "expires_at": "Link valid until",
                "actions": "Actions"
            },
            "link_status": {
                "created": "Issued",
                "opened": "Opened",
                "in_progress": "Interview in progress",
                "completed": "Interview completed",
                "revoked": "Revoked"
            },
            "invite_status": {
                "not_sent": "Not sent",
                "queued": "Queued",
                "sent": "Sent",
                "failed": "Failed to send"
            },
            "invite_sent_at": "Accepted by the mail service on {date}",
            "invite_failure": {
                "rejected": "The mail service rejected the email — send the link to the candidate yourself",
                "transport": "Sending failed — send the link to the candidate yourself",
                "revoked": "The link was revoked",
                "sending_disabled": "Email sending is turned off",
                "blocked": "The address is in the stop list — send the link to the candidate yourself"
            }
        },
        "issue_dialog": {
            "title": "Issue a personal link",
            "name": "First name",
            "last_name": "Last name",
            "email": "Email",
            "phone": "Phone",
            "attempts": "Attempts allowed",
            "expires_at": "Link valid until",
            "expires_hint": "Leave empty to inherit the vacancy expiry",
            "submit": "Issue the link",
            "close": "Close",
            "result_title": "Link issued",
            "warning": "Copy the link now — it is shown exactly once. Only its hash is stored, so the link cannot be recovered: a lost one has to be revoked and issued again.",
            "copy": "Copy",
            "copied": "Copied",
            "send_invite": "Send an invitation to {email}",
            "send_invite_no_email": "Send an invitation by email",
            "send_invite_blocked": "This address is in the stop list — the email will not be sent",
            "invite_queued": "Invitation queued for {email}",
            "invite_blocked": "Invitation not sent: {email} is in the stop list. Send the link to the candidate yourself"
        },
        "import_dialog": {
            "title": "Import candidates",
            "subtitle": "Every row in the file becomes one candidate and one personal link.",
            "file": "Candidate list file",
            "columns": "Columns: First name, Last name, Email, Phone",
            "limits": "xlsx or semicolon-separated CSV, up to 200 rows and 10 MB",
            "size_error": "The file is larger than 10 MB",
            "download_example": "Download template",
            "note_title": "The links are visible only in the downloaded file",
            "note_text": "The file downloads as soon as the import finishes. Only the link hashes are stored, so there is no way to export the links a second time — keep the file.",
            "submit": "Import",
            "cancel": "Cancel",
            "result_title": "Links issued",
            "result": "Links issued: {count}. The file has been downloaded.",
            "invites_blocked": "Invitations not sent: {count}. These addresses are in the stop list — send the links to those candidates yourself.",
            "saved_title": "Keep the downloaded file",
            "saved_text": "It is the only copy of these links: the database stores just their hashes. A lost link can only be revoked and issued again.",
            "download_again": "Download the file again",
            "errors_title": "Rejected rows",
            "error_row": "Row {row}: {error}",
            "errors_truncated": "…and {count} more rejected rows. The first 50 are listed above.",
            "send_invites": "Email invitations to the candidates",
            "send_invites_hint": "Candidates without an email address will not get one"
        }
    },
    "recruiting": "Recruiting",
    "ai-reports": "AI reports",
    "ai-reports-page": {
        "title": "AI reports",
        "subtitle": "Describe the report in plain words — we build the spec, show a preview and export it to Excel.",
        "status": {
            "draft": "Draft",
            "pending": "Building",
            "ready": "Ready",
            "failed": "Failed"
        },
        "list": {
            "title": "My reports",
            "new": "New report",
            "empty": "No reports yet. Click “New report” and describe what you need.",
            "untitled": "Untitled",
            "delete": "Delete report",
            "delete_confirm": "Delete this report together with the generated file?",
            "deleted": "Report deleted"
        },
        "dialog": {
            "title": "Dialog",
            "open_dictionary": "Data reference",
            "placeholder": "For example: how many games each department ran last quarter",
            "send": "Send",
            "empty_title": "What should the report show?",
            "empty_text": "Write it in plain words: which data, for which period and in which breakdown. If something is missing, I will ask.",
            "examples_title": "For example:",
            "examples": {
                "e1": "How many games each department ran last quarter",
                "e2": "Average skill score in the sales department for 2026",
                "e3": "Employees who have not played for more than a month",
                "e4": "Candidates by vacancy and their link statuses for the last 30 days"
            },
            "thinking": "Building the report…",
            "waiting_hint": "The answer will appear here on its own — no need to refresh the page.",
            "retry": "Retry",
            "dismiss": "Dismiss",
            "spec_ready": "The report is ready — check the preview below and build the file.",
            "stuck_title": "We seem to be going in circles",
            "stuck_text": "Open the data reference and rephrase the request using its wording — that is faster than answering one more clarifying question.",
            "rejected_title": "This report cannot be built yet",
            "reason": {
                "no_such_measure": "There is no such measure in our data. Check the list of measures in the reference.",
                "no_such_field": "There is no such field in our data. Check the list of fields in the reference.",
                "cross_dataset": "The request needs data from two datasets at once. Split it into two reports.",
                "window_function": "Shares of the total, ranking positions and comparison with the previous period are not supported yet.",
                "other": "The request goes beyond the available data. Check the reference and try a different wording."
            },
            "usage": {
                "employees": "no employees | {n} employee | {n} employees",
                "games": "no games | {n} game | {n} games",
                "scenarios": "no scenarios | {n} scenario | {n} scenarios",
                "evaluations": "no evaluations | {n} evaluation | {n} evaluations",
                "candidates": "no candidates | {n} candidate | {n} candidates"
            },
            "option_created_at": "added {date}"
        },
        "preview": {
            "title": "Preview",
            "no_report": "Pick a report on the left or start a new one.",
            "no_spec": "Describe the report in the dialog — the preview appears as soon as the request is understood.",
            "spec_title": "What the report will contain",
            "rows_hint": "First {count} rows shown",
            "total": "Rows in total: {count}",
            "zero_rows": "This request returns no rows at all. Widen the period or drop filters — there is no point in building an empty file.",
            "zero_rows_hint": "Check the filter values — there may be no data for them",
            "duplicate_rows": "Some preview rows are identical: the chosen columns do not tell this dataset’s records apart. Check what one row actually means here — a column that distinguishes them may be missing.",
            "too_many_rows": "The report has {count} rows, the maximum is {max}. Narrow the period or add filters: above the cap the file is not built at all rather than truncated.",
            "generate": "Build the file",
            "regenerate": "Rebuild",
            "queued": "The file is being built — the card updates itself once it is ready.",
            "failed": "The report could not be built",
            "download": "Download .xlsx",
            "downloads": "Downloads: {count}",
            "ttl_warning": "The file is kept for {days} days and then deleted — download it right away.",
            "expires_at": "Available until {date}",
            "expired": "The file was deleted when its retention period ended — build the report again."
        },
        "spec": {
            "dataset": "Data",
            "columns": "Columns",
            "measures": "Measures",
            "group_by": "Breakdown",
            "period": "Period",
            "period_value": "{field}: from {from} to {to}",
            "period_all": "Entire available period",
            "filters": "Filters",
            "having": "Conditions on measures",
            "sort": "Sorting",
            "limit": "Row limit",
            "limit_value": "first {count} rows",
            "granularity": {
                "year": "by year",
                "quarter": "by quarter",
                "month": "by month",
                "week": "by week",
                "day": "by day",
                "dow": "by day of week"
            },
            "dir": {
                "asc": "ascending",
                "desc": "descending"
            },
            "filter": {
                "equals": "{field} — {value}",
                "not_equals": "{field} — not {value}",
                "in": "{field} — one of: {value}",
                "not_in": "{field} — except: {value}",
                "gt": "{field} greater than {value}",
                "gte": "{field} at least {value}",
                "lt": "{field} less than {value}",
                "lte": "{field} at most {value}",
                "contains": "{field} contains “{value}”",
                "between": "{field} — from {from} to {to}",
                "is_null": "{field} is empty",
                "is_not_null": "{field} is filled in"
            }
        },
        "value": {
            "yes": "Yes",
            "no": "No"
        },
        "dictionary": {
            "title": "Data reference",
            "subtitle": "Everything that can be pulled into a report. The list is live: it is the same one the spec is built from.",
            "fields": "Fields",
            "measures": "Measures",
            "values": "Values",
            "show_values": "Show your organization’s values",
            "hide_values": "Hide values",
            "values_error": "The values could not be loaded — try again.",
            "values_empty": "Your organization has no values for this field yet.",
            "limits": {
                "title": "What a report cannot do",
                "pivot": "A cross-tab with a column per participant or per question will not be built. Ask for the long form instead: one row per participant-and-question pair.",
                "window": "Month-over-month change, share of the total, ranking position and “the top three in each department” are out of reach. Take the breakdown by month and finish the arithmetic in Excel.",
                "missing": "What the system does not store will never show up in a report: salaries, NPS and anything else kept elsewhere, under any name."
            },
            "empty": "The reference is empty — contact your administrator.",
            "close": "Close"
        },
        "errors": {
            "generic": "Something went wrong. Please try again.",
            "detail": "Not understood: {value}",
            "rate_limit": "Too many requests. Wait a minute and try again.",
            "download": "The file could not be downloaded.",
            "turn_failed": "The answer could not be obtained. Please send your request again.",
            "turn_stuck_in_queue": "The request never started processing — it waited in the queue for too long. Send it again.",
            "unknown_resolution": "This option is out of date — the report has changed in the meantime. Open it again and refine your request."
        }
    },
    "externalLaunch": {
        "document_title": "Practice session",
        "intro": {
            "title": "Practice conversation",
            "lead": "You are about to talk with a virtual counterpart. The conversation is recorded and evaluated, and the result goes back to your learning system.",
            "requirements_title": "What you will need",
            "requirement_mic": "A working microphone, ideally a headset",
            "requirement_camera": "A camera is optional, but the conversation feels more natural with it",
            "requirement_browser": "A computer with an up-to-date Chrome, Edge or Safari",
            "requirement_network": "A stable connection and a quiet place where nobody interrupts you",
            "start": "Start"
        },
        "relaunch_hint": "Return to your learning system and open the material again.",
        "saving": "Saving the result…",
        "review": {
            "document_title": "Session review",
            "attempt": "Attempt {number}",
            "result": {
                "passed": "Passed",
                "failed": "Not passed",
                "pending": "Not evaluated yet"
            },
            "score_of_100": "{score} out of 100",
            "threshold": "Passing score: {threshold}",
            "skills_title": "Skills and recommendations",
            "skills_empty": "There is no skill-by-skill feedback for this attempt yet.",
            "comments_title": "Comments on the recording",
            "comments_empty": "There are no comments on this recording.",
            "loading": "Loading the review",
            "error": {
                "not_found": {
                    "title": "The link does not work",
                    "text": "The review is no longer available: the link has expired or the attempt was withdrawn."
                },
                "expired": {
                    "title": "The page has expired",
                    "text": "Open the review again from the link in your learning system."
                },
                "generic": {
                    "title": "Cannot show the review",
                    "text": "Something went wrong on our side. Try opening the link again."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Thank you!",
                "text": "The conversation is over. The result will appear in your learning system once the evaluation is ready. You can close this page."
            },
            "aborted": {
                "title": "The conversation did not start",
                "text": "Something went wrong before the conversation began."
            },
            "token_expired": {
                "title": "The session has expired",
                "text": "Access to this conversation is no longer valid."
            },
            "not_found": {
                "title": "The link does not work",
                "text": "The address may contain a typo, or the link is no longer valid."
            },
            "rate_limited": {
                "title": "Too many attempts",
                "text": "Wait a minute before trying again."
            },
            "generic": {
                "title": "Cannot start right now",
                "text": "Something went wrong on our side."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "The material is closed",
                "text": "This material is no longer available for practice."
            },
            "publication_draft": {
                "title": "The material is not published yet",
                "text": "Practice for this material has not been opened yet."
            },
            "publication_expired": {
                "title": "The material has expired",
                "text": "The period during which this material could be practised is over."
            },
            "feature_disabled": {
                "title": "The material is closed",
                "text": "Practice from the learning system is turned off for your organization."
            },
            "connection_disabled": {
                "title": "The material is closed",
                "text": "The connection to your learning system has been turned off. Contact the person who assigned the course."
            },
            "launch_limit_reached": {
                "title": "The limit is reached",
                "text": "This material has been used for the maximum number of conversations."
            },
            "daily_budget_exhausted": {
                "title": "Enough for today",
                "text": "You have reached the number of conversations allowed per day. Try again tomorrow."
            },
            "attempts_exhausted": {
                "title": "No attempts left",
                "text": "You have used every attempt allowed for this material."
            },
            "quota_exhausted": {
                "title": "Cannot start right now",
                "text": "Your organization has no conversations left. Contact the person who assigned the course."
            },
            "user_limit_reached": {
                "title": "Cannot start right now",
                "text": "Your organization has no free seats left. Contact the person who assigned the course."
            },
            "scenario_unavailable": {
                "title": "The material is unavailable",
                "text": "The conversation behind this material no longer exists."
            },
            "assignment_check_unavailable": {
                "title": "Cannot start right now",
                "text": "We could not confirm that this material is assigned to you. Contact the person who assigned the course."
            },
            "code_invalid": {
                "title": "The link is no longer valid",
                "text": "This link has already been used or its time has run out."
            },
            "channel_verification_failed": {
                "title": "The learning system did not respond",
                "text": "We could not confirm the request with your learning system."
            },
            "external_system_unavailable": {
                "title": "The learning system is not responding",
                "text": "We could not check your course assignment in the learning system. Try again in a few minutes."
            },
            "user_not_found": {
                "title": "We could not identify you",
                "text": "There is no account for you here, and your organization does not create them automatically. Contact the person who assigned the course."
            },
            "user_unavailable": {
                "title": "Your account is disabled",
                "text": "Contact the person who assigned the course."
            },
            "user_deleted": {
                "title": "Your account is deleted",
                "text": "Contact the person who assigned the course."
            },
            "email_taken_linking_disabled": {
                "title": "We could not identify you",
                "text": "Your email address already belongs to another account here. Contact the person who assigned the course."
            },
            "service_role_not_allowed": {
                "title": "This account cannot practise",
                "text": "Administrator accounts do not take practice conversations. Use your own learning account."
            },
            "unverified_request": {
                "title": "We could not confirm the request",
                "text": "Your learning system did not confirm that this conversation was started by you."
            }
        },
        "manage": {
            "nav": {
                "group": "External launch",
                "publications": "Publications",
                "connections": "LMS connections"
            },
            "messages": {
                "error": "Something went wrong. Try again.",
                "load_error": "Could not load the data."
            },
            "connections": {
                "title": "LMS connections",
                "subtitle": "Accounts of learning systems this organization launches practice from.",
                "create": "Add connection",
                "edit": "Edit",
                "set_credentials": "Set credentials",
                "empty": "No connections yet.",
                "secret_missing": "Not set",
                "no_expiry": "Does not expire",
                "headers": {
                    "account": "Account",
                    "base_url": "Address",
                    "client_id": "Client ID",
                    "secret": "Secret",
                    "status": "Status",
                    "expires_at": "Credentials expire",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "No credentials",
                    "active": "Active",
                    "expired": "Credentials expired",
                    "disabled": "Disabled"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "New connection",
                    "edit_title": "Connection",
                    "immutable_hint": "The learning system and the account cannot be changed: they define the learner identity space. A different account is a new connection.",
                    "lms_label": "Learning system",
                    "account_key_label": "Account",
                    "account_key_hint": "The account identifier in the learning system.",
                    "base_url_label": "iSpring REST API address",
                    "base_url_hint": "For example, https://api-learn.ispringlearn.ru. This is not your company portal address: the secret is sent here.",
                    "base_url_https": "The address must start with https://",
                    "enabled_label": "Connection is on",
                    "enabled_hint": "A connection is never deleted — it is turned off. Publications and launches stay in the lists, but new launches are refused and results stop going to the learning system.",
                    "credentials_optional": "Credentials are optional. Without them the connection works in limited mode.",
                    "client_id_label": "Client ID",
                    "secret_label": "Secret",
                    "secret_hint": "Stored encrypted. It can never be read back — only the last four characters are shown.",
                    "expires_at_label": "Credentials expire",
                    "expires_at_hint": "Leave empty if the credentials do not expire."
                },
                "credentials_dialog": {
                    "title": "Credentials",
                    "lead": "The new secret replaces the previous one. The connection keeps its identifier, and learner links and launches stay where they are.",
                    "secret_hint": "The previous secret is not needed and cannot be read back."
                },
                "messages": {
                    "saved": "Connection saved",
                    "credentials_saved": "Credentials saved"
                }
            },
            "publications": {
                "title": "Publications",
                "subtitle": "Scenarios opened for launch from a learning system.",
                "create": "New publication",
                "edit": "Edit",
                "enable": "Turn on",
                "disable": "Turn off",
                "open_journal": "Journal",
                "download_package": "Download package",
                "empty": "No publications yet.",
                "no_connections": "There is no connection to a learning system yet. A platform administrator sets one up.",
                "no_expiry": "No expiry",
                "attempts_unlimited": "Unlimited",
                "immutable_hint": "The connection, the scenario and the delivery channel cannot be changed: they are built into the package already uploaded to the learning system. Everything else applies without rebuilding it.",
                "headers": {
                    "scenario": "Scenario",
                    "connection": "Connection",
                    "channel": "Channel",
                    "status": "Status",
                    "settings": "Settings",
                    "expires_at": "Expires",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Attempts: {value}",
                    "threshold": "Pass mark: {value}"
                },
                "status": {
                    "draft": "Draft",
                    "active": "Active",
                    "disabled": "Disabled"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Status only",
                    "status_and_score": "Status and score",
                    "status_score_and_review": "Status, score and a link to the review"
                },
                "warnings": {
                    "limited_mode": "Limited mode: the score and the outcome will not appear in the learning system, and the assignment check is not performed.",
                    "connection_disabled": "The connection is turned off: launches through this publication are not accepted at all until an administrator turns the connection back on.",
                    "assignment_check_off": "With the switch off, a course reassignment is not detected.",
                    "no_course_binding": "The publication is not bound to a course — the score will not reach the learning system."
                },
                "dialog": {
                    "connection_label": "Connection",
                    "scenario_label": "Scenario",
                    "channel_label": "Delivery channel",
                    "channel_hint": "Built into the package and cannot be changed afterwards.",
                    "status_label": "Status",
                    "status_hint": "A publication is never deleted — it is turned off. After that new launches are refused and results that have not gone out yet are cancelled.",
                    "settings_section": "Attempt settings",
                    "attempts_label": "Attempts per learner",
                    "attempts_unlimited": "Without a limit",
                    "daily_budget_label": "Launches per day per learner",
                    "daily_budget_hint": "Protects the quota: every started conversation is charged and never returned.",
                    "result_mode_label": "What goes back to the learning system",
                    "pass_threshold_label": "Pass mark, 0–100",
                    "result_wait_label": "Wait for the evaluation, hours",
                    "result_wait_hint": "After that the launch reports “no result”.",
                    "launch_limit_label": "Total launch limit",
                    "launch_limit_hint": "Leave empty for no limit.",
                    "assignment_check_label": "Check the assignment in the learning system",
                    "binding_section": "Binding in the learning system",
                    "external_course_label": "Course ID",
                    "external_item_label": "Item ID",
                    "expires_label": "Publication expires",
                    "expires_hint": "Leave empty if the publication does not expire."
                },
                "key_dialog": {
                    "title": "The publication is created",
                    "warning": "The key is shown once and only here. It cannot be read back from anywhere — copy it now and put it into the package settings. Losing it means creating a new publication.",
                    "key_label": "Publication key",
                    "copied": "Copied",
                    "package_hint": "The key is already inside the package, so there is nothing to paste anywhere. Download the package and upload it to the learning system. You can download it again at any time on the Publications page."
                },
                "messages": {
                    "saved": "Publication saved",
                    "enabled": "Publication turned on",
                    "disabled": "Publication turned off",
                    "download_failed": "Could not download the package. Refresh the page and try again."
                }
            },
            "journal": {
                "title": "Launch journal",
                "unknown_scenario": "Scenario unavailable",
                "back": "To publications",
                "revoke": "Revoke the attempt",
                "revoke_confirm": "Revoke this attempt? The learner loses access to the conversation, and deliveries that have not gone out are cancelled.",
                "retry_delivery": "Retry",
                "empty_launches": "No launches yet.",
                "empty_events": "No events yet.",
                "no_deliveries": "No deliveries for this attempt.",
                "not_held_quota_charged": "Did not happen, quota charged",
                "relaunches": "returns: {value}",
                "last_launch": "last launch: {value}",
                "result_deadline": "Waiting for the evaluation until {value}",
                "learner_contacts": "Address sent by the learning system: {email}. Launched from: {ip}",
                "score_passed": "{value} — passed",
                "score_failed": "{value} — failed",
                "tabs": {
                    "launches": "Attempts",
                    "events": "Events"
                },
                "headers": {
                    "learner": "Learner",
                    "user": "Account",
                    "attempt": "Attempt",
                    "status": "Status",
                    "game": "Conversation",
                    "started_at": "Started",
                    "actions": " ",
                    "event_type": "Event",
                    "refusal": "Reason",
                    "request_proof": "Request proof",
                    "ip": "Address",
                    "user_agent": "Client",
                    "happened_at": "When"
                },
                "launch_status": {
                    "created": "Link issued",
                    "started": "In progress",
                    "not_held": "Did not happen",
                    "awaiting_result": "Waiting for the evaluation",
                    "result_ready": "Result delivered",
                    "evaluation_failed": "No evaluation",
                    "result_timed_out": "Waiting time ran out",
                    "assignment_changed": "Assignment changed",
                    "revoked": "Revoked"
                },
                "delivery": {
                    "version": "Version",
                    "status": "Status",
                    "outcome": "Outcome",
                    "result": "Result",
                    "score": "Score",
                    "attempts": "Tries",
                    "last_attempt": "Last try",
                    "external_state": "State in the learning system"
                },
                "delivery_status": {
                    "pending": "Queued",
                    "in_progress": "Sending",
                    "done": "Done",
                    "needs_attention": "Needs attention"
                },
                "delivery_outcome": {
                    "accepted": "Accepted",
                    "confirmed": "Confirmed",
                    "rejected_by_external": "Rejected",
                    "retry": "Retry scheduled",
                    "cancelled": "Cancelled",
                    "assignment_changed": "Assignment changed"
                },
                "result": {
                    "passed": "Passed",
                    "failed": "Failed",
                    "not_held": "Did not happen",
                    "no_result": "No result"
                },
                "refusal": {
                    "publication_disabled": "Publication turned off",
                    "publication_draft": "Publication is still a draft",
                    "publication_expired": "Publication expired",
                    "feature_disabled": "External launch turned off",
                    "connection_disabled": "Connection turned off",
                    "launch_limit_reached": "Launch limit reached",
                    "daily_budget_exhausted": "Daily budget exhausted",
                    "attempts_exhausted": "Attempts exhausted",
                    "quota_exhausted": "Organization quota exhausted",
                    "user_limit_reached": "No free seats left",
                    "scenario_unavailable": "Scenario unavailable",
                    "assignment_check_unavailable": "Assignment check unavailable",
                    "code_invalid": "Link already used or expired",
                    "channel_verification_failed": "Learning system did not confirm the request",
                    "external_system_unavailable": "Learning system did not respond to the assignment check",
                    "user_not_found": "No account for this learner",
                    "user_unavailable": "Learner account disabled",
                    "user_deleted": "Learner account deleted",
                    "email_taken_linking_disabled": "Email belongs to another account",
                    "service_role_not_allowed": "Service account cannot practise",
                    "unverified_request": "Request not confirmed"
                },
                "event_type": {
                    "launch_refused": "Launch refused",
                    "exchange_refused": "Link refused",
                    "exchange_succeeded": "Link used"
                },
                "request_proof": {
                    "unverified": "Not confirmed",
                    "assignment_verified": "Assignment confirmed"
                },
                "messages": {
                    "retry_queued": "Retry queued",
                    "revoked": "Attempt revoked"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Training",
            "interview": "Interview"
        },
        "load": {
            "loading": "Loading the session…",
            "failed": "Couldn't load the session. Check your connection and try again.",
            "scenarioFailed": "The scenario didn't load",
            "scenarioRetry": "Retry"
        },
        "leave": {
            "confirm": "The conversation is still going. Leaving won't end it, and the time keeps running. Leave the page?",
            "confirmEnd": "The conversation is still going. If you leave, it will end and be evaluated on what you managed to cover. Leave?"
        },
        "elsewhere": {
            "interviewTitle": "The interview is open in another tab",
            "interviewText": "The interview is going on in another tab or on another device. Continue it there — you can close this tab.",
            "conversationTitle": "The conversation is open in another tab",
            "conversationText": "The conversation is going on in another tab or on another device. Continue it there — you can close this tab."
        },
        "prep": {
            "header": {
                "backToSessions": "To sessions",
                "themeToggleAriaLabel": "Switch theme"
            },
            "scenario": {
                "sectionLabel": "Scenario",
                "competenceLabel": "Competence being assessed",
                "gameNumber": "Session #{number}",
                "duration": "{minutes} min",
                "readFull": "Read in full",
                "generalLabel": "General information",
                "playerLabel": "Information for you"
            },
            "selfCamera": {
                "previewLabel": "Your camera preview",
                "off": "Camera is off"
            },
            "notes": {
                "empty": "Empty"
            },
            "start": {
                "button": "Start session",
                "interviewButton": "Start interview",
                "resumeButton": "Back to the conversation",
                "resumeHint": "The conversation is already under way — the time keeps running."
            }
        },
        "equipment": {
            "status": {
                "checking": "Checking equipment",
                "waiting": "Waiting for permission",
                "denied": "Access denied",
                "busy": "Device busy",
                "noCamera": "No camera",
                "missing": "No microphone",
                "dismissed": "Access not granted",
                "ready": "Equipment ready"
            },
            "checking": {
                "title": "Checking your microphone and camera…"
            },
            "waiting": {
                "title": "Allow microphone access",
                "cameraTitle": "Allow access to the camera",
                "description": "The browser's permission request is already open. Without a microphone the conversation can't start."
            },
            "denied": {
                "title": "The browser is blocking the microphone",
                "cameraTitle": "The browser blocks the camera",
                "description": "Your browser remembered the block. Allow microphone access in the site settings and reload the page.",
                "cameraDescription": "Your browser remembered the block. Allow camera access in the site settings and reload the page.",
                "showInstructions": "Show me how",
                "hideInstructions": "Hide",
                "chromeEdge": {
                    "browser": "Chrome and Edge",
                    "text": "Click the lock icon to the left of the address bar, open \"Site settings\", allow \"Microphone\" and reload the page."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Open the Safari menu → \"Settings for This Website\", allow \"Microphone\" and reload the page."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Click the microphone icon in the address bar, remove the block for this site and reload the page."
                },
                "system": {
                    "title": "Your system blocks the browser from the microphone",
                    "cameraTitle": "Your system blocks the browser from the camera",
                    "macos": "macOS: System Settings → Privacy & Security → Microphone (or Camera) → turn on your browser, then restart it.",
                    "windows": "Windows: Settings → Privacy & security → Microphone (or Camera) → allow access for apps and your browser, then press \"Retry\"."
                }
            },
            "busy": {
                "title": "The microphone is busy with another app",
                "cameraTitle": "The camera is used by another app",
                "description": "Usually it's a call left running in the background. Close it and click \"Retry\".",
                "retry": "Retry"
            },
            "noCamera": {
                "title": "No camera",
                "description": "You'll be heard, but not seen.",
                "requiredByScenario": "This conversation requires a camera. Connect one to continue."
            },
            "missing": {
                "title": "No microphone found",
                "description": "Connect a microphone and press \"Retry\". The conversation can't start without it."
            },
            "dismissed": {
                "title": "Microphone access wasn't granted",
                "cameraTitle": "Camera access wasn't granted",
                "description": "The browser window was closed without an answer. Press \"Retry\" and allow access."
            },
            "ready": {
                "title": "Equipment ready"
            },
            "micLabel": "Microphone",
            "cameraLabel": "Camera",
            "chooseMic": "Choose microphone",
            "chooseCamera": "Choose camera",
            "micLevelHint": "Say something",
            "speakerValue": "Speaker: {name}",
            "configure": "Set up",
            "dialog": {
                "title": "Equipment",
                "lockedDuringConversation": "Devices can't be changed during the conversation.",
                "micSelectLabel": "Microphone",
                "cameraSelectLabel": "Camera",
                "speakerSelectLabel": "Speaker",
                "noCameraOption": "No camera",
                "record": "Record 3 seconds",
                "recording": "Recording…",
                "recordFailed": "Couldn't record. Try again.",
                "listen": "Play back",
                "playing": "Playing…",
                "done": "Done",
                "closeAriaLabel": "Close dialog"
            },
            "unnamed": {
                "microphone": "Microphone {number}",
                "camera": "Camera {number}",
                "speaker": "Speaker {number}"
            },
            "cameraWarmup": {
                "preview": "Camera is turning on",
                "title": "Microphone ready",
                "description": "The camera will catch up — usually in a second or two.",
                "slowHint": "Camera not turning on? Choose another one in the settings."
            }
        },
        "recording": {
            "videoAndAudio": "The conversation and video are being recorded.",
            "audioOnly": "The conversation is being recorded.",
            "accessSelfAndEvaluators": "The recording is available to you and to whoever evaluates your work.",
            "accessEvaluators": "The recording is available to whoever evaluates your work."
        },
        "scenario": {
            "video": "Video from the scenario author"
        },
        "notes": {
            "title": "Session notes",
            "placeholder": "What you want to practice, phrasing you've prepared",
            "saving": "Saving…",
            "saved": "Saved",
            "saveError": "Couldn't save",
            "visibility": "Notes are visible to you and to whoever evaluates the session.",
            "unsupported": "These notes contain elements that can't be edited here. They are kept unchanged."
        },
        "stage": {
            "agentState": {
                "speaking": "Speaking",
                "listening": "Listening",
                "thinking": "Thinking"
            },
            "micOffWarning": "Microphone is off — the other side can't hear you",
            "micOnAriaLabel": "Turn off microphone",
            "micOffAriaLabel": "Turn on microphone",
            "micOff": "Microphone off",
            "micOnAnnouncement": "Microphone on",
            "captionsLabel": "Captions",
            "captionsOnAriaLabel": "Hide captions",
            "captionsOffAriaLabel": "Show captions",
            "talkBalance": {
                "title": "Talk balance",
                "you": "You",
                "interlocutor": "Interlocutor"
            },
            "connectionQuality": {
                "excellent": "Excellent connection",
                "good": "Good connection",
                "poor": "Weak connection",
                "unknown": "Connection quality unknown"
            },
            "selfCameraLabel": "You",
            "timeWarning": {
                "lastMinute": "One minute left — time to wrap up",
                "finalSeconds": "15 seconds — finish your thought"
            },
            "timeUp": {
                "title": "Time's up",
                "text": "The conversation will close on its own; it can't be extended.",
                "closing": "Closing the conversation…"
            },
            "voiceOnly": "Voice mode — this scenario has no video",
            "interlocutorConnecting": {
                "title": "Interlocutor is connecting",
                "hint": "Usually 2–4 seconds"
            },
            "layout": {
                "label": "Side by side",
                "sideTitle": "Place side by side",
                "focusTitle": "Enlarge the interlocutor"
            }
        },
        "panels": {
            "scenario": "Scenario",
            "transcript": "Transcript",
            "transcriptEmpty": "Finished replies will appear here.",
            "notes": "Notes",
            "characterMemoryTab": "What the character remembers",
            "openAriaLabel": "Open the \"{panel}\" panel",
            "closeAriaLabel": "Close the \"{panel}\" panel"
        },
        "sound": {
            "label": "Sound",
            "volumeLabel": "Volume",
            "speakerLabel": "Speaker"
        },
        "end": {
            "button": "End",
            "confirmTitle": "End the conversation?",
            "elapsed": "{elapsed} elapsed out of {total}.",
            "partialEvaluationNotice": "The conversation will be evaluated on what you managed to cover.",
            "continue": "Continue",
            "notSent": "The conversation will end on time: the server didn't respond to the end request."
        },
        "wait": {
            "title": "Preparing the conversation",
            "hint": "This usually takes 1–3 minutes. Don't close the page — we'll start automatically.",
            "nextTry": "Next attempt in {time}",
            "trying": "Trying to start…",
            "retrying": "Not yet. Trying again in {time}",
            "cancel": "Cancel",
            "failed": {
                "title": "Couldn't start the conversation",
                "text": "There are no free slots right now. Your microphone and camera settings are saved — try again in a couple of minutes.",
                "retry": "Try again"
            }
        },
        "connection": {
            "reconnecting": "Connection lost, reconnecting…",
            "restored": "Connection restored",
            "failed": "Couldn't restore the connection",
            "retry": "Retry"
        },
        "hotkeys": {
            "title": "Keyboard shortcuts",
            "showHintAriaLabel": "Show keyboard shortcuts",
            "micToggle": "Toggle microphone",
            "scenarioPanel": "Scenario: open and close the panel",
            "transcriptPanel": "Transcript",
            "notesPanel": "Notes",
            "captionsToggle": "Toggle captions",
            "closeTopLayer": "Close the panel, popover or dialog",
            "endConfirm": "End — opens the confirmation",
            "showHint": "Show this hint"
        },
        "intro": {
            "candidate": {
                "greeting": "Hello, {name}!",
                "leadWithVacancy": "{organization} invites you to an interview with a virtual interlocutor for the \"{vacancy}\" position.",
                "duration": "The interview will take about {minutes} min.",
                "requirementsTitle": "What you'll need",
                "requirementMic": "A working microphone, ideally a headset",
                "requirementCameraRequired": "Camera turned on: it's required for this interview",
                "requirementCameraOptional": "A camera isn't required, but it makes the conversation feel more natural",
                "requirementBrowser": "A computer with a recent Chrome, Edge or Safari",
                "requirementNetwork": "A stable connection and a quiet place where you won't be interrupted",
                "consentTextLabel": "Consent text",
                "consentAccept": "I have read the text and consent to the processing of my personal data",
                "next": "Next"
            },
            "launch": {
                "title": "Practice conversation",
                "lead": "You're about to talk with a virtual interlocutor. The conversation is recorded and evaluated, and the result will go back to your learning system.",
                "requirementsTitle": "What you'll need",
                "requirementMic": "A working microphone, ideally a headset",
                "requirementCamera": "A camera isn't required, but it makes the conversation livelier",
                "requirementBrowser": "A computer with a recent Chrome, Edge or Safari",
                "requirementNetwork": "A stable connection and a quiet place where you won't be interrupted",
                "start": "Start"
            }
        },
        "finished": {
            "candidate": {
                "title": "Thank you!",
                "text": "The interview is over. The result will go to the recruiter, who will get in touch with you. You can close this page now."
            },
            "launch": {
                "title": "Thank you!",
                "text": "The conversation is over. The result will appear in your learning system once it's evaluated. You can close this page now."
            }
        },
        "closeDialogAriaLabel": "Close dialog"
    },
    "loopAvatars": {
        "title": "Loop avatars",
        "upload": "Upload avatar",
        "newVersion": "New version",
        "newVersionHint": "“{name}”, current version {version}. The new package replaces the videos in all profiles with this avatar.",
        "edit": "Edit avatar",
        "delete": "Delete avatar",
        "empty": "No avatars yet",
        "headers": {
            "poster": "Poster",
            "name": "Name",
            "gender": "Gender",
            "emotion": "Emotion",
            "visibility": "Visibility",
            "version": "Version",
            "profiles": "Profiles"
        },
        "gender": {
            "male": "Male",
            "female": "Female"
        },
        "emotion": {
            "calm": "Calm",
            "friendly": "Friendly",
            "strict": "Strict"
        },
        "visibility": {
            "all": "All organizations"
        },
        "fields": {
            "package": "Avatar package (.zip)"
        },
        "packageHint": "ZIP up to 100 MB with manifest.json, listen.mp4, talk.mp4, transitions.json and poster.jpg",
        "validation": {
            "packageTooLarge": "The package must not exceed 100 MB"
        },
        "errors": {
            "requestFailed": "Request failed. Please try again."
        },
        "confirmDetach": "Profiles to be unlinked: {count}. They will switch to the photo. Save?",
        "confirmDelete": "Delete avatar “{name}”?",
        "confirmDeleteWithProfiles": "Avatar “{name}” is used in profiles: {count}. They will switch to the photo. Delete?"
    },
    "ttsVoices": {
        "title": "TTS voices",
        "create": "Add voice",
        "edit": "Edit voice",
        "delete": "Delete voice",
        "replaceSample": "Replace sample",
        "replaceSampleHint": "“{name}”, current sample version {version}. The new sample will play in all profiles with this voice.",
        "empty": "No voices yet",
        "play": "Play sample",
        "stop": "Stop",
        "headers": {
            "name": "Name",
            "provider": "Provider",
            "externalId": "Voice ID",
            "gender": "Gender",
            "languages": "Languages",
            "visibility": "Visibility",
            "sample": "Sample",
            "profiles": "Profiles"
        },
        "gender": {
            "male": "Male",
            "female": "Female"
        },
        "visibility": {
            "all": "All organizations"
        },
        "fields": {
            "sample": "Voice sample",
            "speed": "Speech speed"
        },
        "sampleHint": "MP3, MP4 or M4A up to 5 MB",
        "sampleOptionalHint": "Optional — the sample will be generated with the voice by its ID. MP3, MP4 or M4A up to 5 MB",
        "synthesizeSample": "Generate again",
        "speedChangedHint": "Generate the sample again to hear the new speed.",
        "speedSamplePromptTitle": "Speed changed",
        "speedSamplePrompt": "The sample still plays at the previous speed. Generate it again? The current sample will be replaced.",
        "saveAndSynthesize": "Save and generate",
        "saveOnly": "Save only",
        "validation": {
            "sampleTooLarge": "The sample must not exceed 5 MB"
        },
        "errors": {
            "requestFailed": "Request failed. Please try again.",
            "sampleUnavailable": "The sample could not be played"
        },
        "confirmDetach": "Profiles to be unlinked: {count}. They will switch to the connector voice. Save?",
        "confirmDelete": "Delete voice “{name}”?",
        "confirmDeleteWithProfiles": "Voice “{name}” is used in profiles: {count}. They will switch to the connector voice. Delete?",
        "picker": {
            "none": "Default voice",
            "empty": "No catalog voices for this gender",
            "loadError": "Could not load voices",
            "playSample": "Play sample: {name}",
            "stopSample": "Stop sample: {name}",
            "sampleUnavailable": "Sample unavailable"
        }
    },
    "realtimeAvatars": {
        "title": "Live avatars",
        "create": "Add avatar",
        "edit": "Edit avatar",
        "delete": "Delete avatar",
        "preview": "Watch preview",
        "empty": "No avatars yet",
        "headers": {
            "poster": "Poster",
            "name": "Name",
            "provider": "Provider",
            "externalId": "Avatar ID",
            "gender": "Gender",
            "visibility": "Visibility",
            "profiles": "Profiles",
            "models": "Anam models"
        },
        "gender": {
            "male": "Male",
            "female": "Female"
        },
        "visibility": {
            "all": "All organizations"
        },
        "nameHint": "Optional — the name from Anam will be used",
        "externalIdHint": "If you change the ID, the poster and preview are loaded from Anam again",
        "errors": {
            "requestFailed": "Request failed. Please try again.",
            "previewUnavailable": "The preview could not be played"
        },
        "confirmDetach": "Profiles to be unlinked: {count}. They will switch to the photo. Save?",
        "confirmDelete": "Delete avatar “{name}”?",
        "confirmDeleteWithProfiles": "Avatar “{name}” is used in profiles: {count}. They will switch to the photo. Delete?",
        "picker": {
            "label": "Live avatars",
            "empty": "No Live avatars available for this profile",
            "emptyFiltered": "No Live avatars of this gender",
            "loadError": "Could not load Live avatars"
        }
    },
    "aiProfileAppearance": {
        "label": "Appearance",
        "photo": "Custom photo",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Mascot",
        "filterGender": "Gender",
        "filterEmotion": "Emotion",
        "avatarsLabel": "Avatars",
        "avatarRequired": "Choose an avatar",
        "liveRequired": "Choose a Live avatar",
        "livePlaceholder": "Your Live avatar will appear here",
        "empty": "No avatars available for this profile",
        "emptyFiltered": "No avatars match the filters",
        "loadError": "Could not load avatars",
        "playPreview": "Play preview: {name}",
        "pausePreview": "Pause preview: {name}"
    },
    "emailStopList": {
        "title": "Email stop list",
        "description": "Emails to these addresses and domains are not sent. A domain entry covers every address of that domain, but not its subdomains.",
        "searchPlaceholder": "Search by address or domain",
        "allReasons": "All reasons",
        "add": "Add",
        "addTitle": "Block an address or domain",
        "empty": "The stop list is empty",
        "editNote": "Edit note",
        "headers": {
            "type": "Type",
            "value": "Address or domain",
            "reason": "Reason",
            "providerReply": "Mail service reply",
            "note": "Note",
            "author": "Added by",
            "createdAt": "Added on",
            "blockedCount": "Emails stopped",
            "lastBlockedAt": "Last stopped"
        },
        "type": {
            "address": "Address",
            "domain": "Domain"
        },
        "reason": {
            "manual": "Added manually",
            "providerRejected": "Rejected by the mail service"
        },
        "author": {
            "system": "System"
        },
        "fields": {
            "value": "Address or domain",
            "valueHint": "Enter a full address or just a domain. A domain blocks all of its addresses, but not subdomains.",
            "note": "Note"
        },
        "errors": {
            "requestFailed": "Something went wrong. Please try again."
        },
        "unblock": {
            "action": "Unblock",
            "confirm": "Unblock {value}?",
            "resultTitle": "Unblock result",
            "result": {
                "removedEverywhere": "Unblocked. The mail service does not have this address in its stop list, so emails will be sent again.",
                "removedLocally": "Domain unblocked. Addresses of this domain that have their own entry stay blocked.",
                "providerNotConfigured": "Only the platform entry was removed: the connection to the mail service is not set up, so its stop list was not checked.",
                "providerUnavailable": "The mail service is unavailable, try again later. The address is still blocked.",
                "stillListedAtProvider": "The address is in the mail service stop list. Remove it in the mail service panel, then click “Unblock again”. If the panel does not show the address, it is in the service’s global stop list and cannot be removed from there."
            },
            "openPanel": "Open the mail service panel",
            "panelPath": "Where to remove it: mail service panel → Products → Email Service → your resource → Stop Lists tab.",
            "retry": "Unblock again"
        },
        "suggestions": {
            "text": "Domain {domain} has {count} blocked addresses. Block the whole domain?",
            "block": "Block domain",
            "confirm": "Block the domain {domain}? Emails to all its addresses will stop. Subdomains are not affected, and the entries for individual addresses stay."
        },
        "check": {
            "title": "Check an address",
            "hint": "Shows whether emails to the address are blocked by the platform or by the mail service",
            "placeholder": "Email address",
            "submit": "Check",
            "resultFor": "Result for {email}",
            "platform": "Platform stop list",
            "platformListed": "Yes — entry “{value}”",
            "provider": "Mail service stop list",
            "listed": "Yes",
            "notListed": "No",
            "providerReasons": "Reasons given by the mail service:",
            "providerNotConfigured": "Connection to the mail service is not set up",
            "providerUnavailable": "The mail service is unavailable, try again later"
        }
    }
}
